// Auto-generated — Google Ads / DataForSEO location + language data
export interface GeoCountry { code: number; name: string; iso: string; }
export interface GeoRegion  { code: number; name: string; full: string; iso: string; }
export interface GeoLanguage { name: string; code: string; }

export const GEO_COUNTRIES: GeoCountry[] = [
  { code: 2004, name: "Afghanistan", iso: "AF" },
  { code: 2008, name: "Albania", iso: "AL" },
  { code: 2012, name: "Algeria", iso: "DZ" },
  { code: 2016, name: "American Samoa", iso: "AS" },
  { code: 2020, name: "Andorra", iso: "AD" },
  { code: 2024, name: "Angola", iso: "AO" },
  { code: 2010, name: "Antarctica", iso: "AQ" },
  { code: 2028, name: "Antigua and Barbuda", iso: "AG" },
  { code: 2032, name: "Argentina", iso: "AR" },
  { code: 2051, name: "Armenia", iso: "AM" },
  { code: 2036, name: "Australia", iso: "AU" },
  { code: 2040, name: "Austria", iso: "AT" },
  { code: 2031, name: "Azerbaijan", iso: "AZ" },
  { code: 2048, name: "Bahrain", iso: "BH" },
  { code: 2050, name: "Bangladesh", iso: "BD" },
  { code: 2052, name: "Barbados", iso: "BB" },
  { code: 2056, name: "Belgium", iso: "BE" },
  { code: 2084, name: "Belize", iso: "BZ" },
  { code: 2204, name: "Benin", iso: "BJ" },
  { code: 2064, name: "Bhutan", iso: "BT" },
  { code: 2068, name: "Bolivia", iso: "BO" },
  { code: 2070, name: "Bosnia and Herzegovina", iso: "BA" },
  { code: 2072, name: "Botswana", iso: "BW" },
  { code: 2076, name: "Brazil", iso: "BR" },
  { code: 2096, name: "Brunei", iso: "BN" },
  { code: 2100, name: "Bulgaria", iso: "BG" },
  { code: 2854, name: "Burkina Faso", iso: "BF" },
  { code: 2108, name: "Burundi", iso: "BI" },
  { code: 2116, name: "Cambodia", iso: "KH" },
  { code: 2120, name: "Cameroon", iso: "CM" },
  { code: 2124, name: "Canada", iso: "CA" },
  { code: 2132, name: "Cape Verde", iso: "CV" },
  { code: 2535, name: "Caribbean Netherlands", iso: "BQ" },
  { code: 2140, name: "Central African Republic", iso: "CF" },
  { code: 2148, name: "Chad", iso: "TD" },
  { code: 2152, name: "Chile", iso: "CL" },
  { code: 2156, name: "China", iso: "CN" },
  { code: 2162, name: "Christmas Island", iso: "CX" },
  { code: 2166, name: "Cocos (Keeling) Islands", iso: "CC" },
  { code: 2170, name: "Colombia", iso: "CO" },
  { code: 2174, name: "Comoros", iso: "KM" },
  { code: 2184, name: "Cook Islands", iso: "CK" },
  { code: 2188, name: "Costa Rica", iso: "CR" },
  { code: 2384, name: "Cote d'Ivoire", iso: "CI" },
  { code: 2191, name: "Croatia", iso: "HR" },
  { code: 2531, name: "Curacao", iso: "CW" },
  { code: 2196, name: "Cyprus", iso: "CY" },
  { code: 2203, name: "Czechia", iso: "CZ" },
  { code: 2180, name: "Democratic Republic of the Congo", iso: "CD" },
  { code: 2208, name: "Denmark", iso: "DK" },
  { code: 2262, name: "Djibouti", iso: "DJ" },
  { code: 2212, name: "Dominica", iso: "DM" },
  { code: 2214, name: "Dominican Republic", iso: "DO" },
  { code: 2218, name: "Ecuador", iso: "EC" },
  { code: 2818, name: "Egypt", iso: "EG" },
  { code: 2222, name: "El Salvador", iso: "SV" },
  { code: 2226, name: "Equatorial Guinea", iso: "GQ" },
  { code: 2232, name: "Eritrea", iso: "ER" },
  { code: 2233, name: "Estonia", iso: "EE" },
  { code: 2748, name: "Eswatini", iso: "SZ" },
  { code: 2231, name: "Ethiopia", iso: "ET" },
  { code: 2242, name: "Fiji", iso: "FJ" },
  { code: 2246, name: "Finland", iso: "FI" },
  { code: 2250, name: "France", iso: "FR" },
  { code: 2258, name: "French Polynesia", iso: "PF" },
  { code: 2260, name: "French Southern and Antarctic Lands", iso: "TF" },
  { code: 2266, name: "Gabon", iso: "GA" },
  { code: 2268, name: "Georgia", iso: "GE" },
  { code: 2276, name: "Germany", iso: "DE" },
  { code: 2288, name: "Ghana", iso: "GH" },
  { code: 2300, name: "Greece", iso: "GR" },
  { code: 2308, name: "Grenada", iso: "GD" },
  { code: 2316, name: "Guam", iso: "GU" },
  { code: 2320, name: "Guatemala", iso: "GT" },
  { code: 2831, name: "Guernsey", iso: "GG" },
  { code: 2324, name: "Guinea", iso: "GN" },
  { code: 2624, name: "Guinea-Bissau", iso: "GW" },
  { code: 2328, name: "Guyana", iso: "GY" },
  { code: 2332, name: "Haiti", iso: "HT" },
  { code: 2334, name: "Heard Island and McDonald Islands", iso: "HM" },
  { code: 2340, name: "Honduras", iso: "HN" },
  { code: 2348, name: "Hungary", iso: "HU" },
  { code: 2352, name: "Iceland", iso: "IS" },
  { code: 2356, name: "India", iso: "IN" },
  { code: 2360, name: "Indonesia", iso: "ID" },
  { code: 2368, name: "Iraq", iso: "IQ" },
  { code: 2372, name: "Ireland", iso: "IE" },
  { code: 2833, name: "Isle of Man", iso: "IM" },
  { code: 2376, name: "Israel", iso: "IL" },
  { code: 2380, name: "Italy", iso: "IT" },
  { code: 2388, name: "Jamaica", iso: "JM" },
  { code: 2392, name: "Japan", iso: "JP" },
  { code: 2832, name: "Jersey", iso: "JE" },
  { code: 2400, name: "Jordan", iso: "JO" },
  { code: 2398, name: "Kazakhstan", iso: "KZ" },
  { code: 2404, name: "Kenya", iso: "KE" },
  { code: 2296, name: "Kiribati", iso: "KI" },
  { code: 2414, name: "Kuwait", iso: "KW" },
  { code: 2417, name: "Kyrgyzstan", iso: "KG" },
  { code: 2418, name: "Laos", iso: "LA" },
  { code: 2428, name: "Latvia", iso: "LV" },
  { code: 2422, name: "Lebanon", iso: "LB" },
  { code: 2426, name: "Lesotho", iso: "LS" },
  { code: 2430, name: "Liberia", iso: "LR" },
  { code: 2434, name: "Libya", iso: "LY" },
  { code: 2438, name: "Liechtenstein", iso: "LI" },
  { code: 2440, name: "Lithuania", iso: "LT" },
  { code: 2442, name: "Luxembourg", iso: "LU" },
  { code: 2450, name: "Madagascar", iso: "MG" },
  { code: 2454, name: "Malawi", iso: "MW" },
  { code: 2458, name: "Malaysia", iso: "MY" },
  { code: 2462, name: "Maldives", iso: "MV" },
  { code: 2466, name: "Mali", iso: "ML" },
  { code: 2470, name: "Malta", iso: "MT" },
  { code: 2584, name: "Marshall Islands", iso: "MH" },
  { code: 2478, name: "Mauritania", iso: "MR" },
  { code: 2480, name: "Mauritius", iso: "MU" },
  { code: 2484, name: "Mexico", iso: "MX" },
  { code: 2583, name: "Micronesia", iso: "FM" },
  { code: 2498, name: "Moldova", iso: "MD" },
  { code: 2492, name: "Monaco", iso: "MC" },
  { code: 2496, name: "Mongolia", iso: "MN" },
  { code: 2499, name: "Montenegro", iso: "ME" },
  { code: 2504, name: "Morocco", iso: "MA" },
  { code: 2508, name: "Mozambique", iso: "MZ" },
  { code: 2104, name: "Myanmar (Burma)", iso: "MM" },
  { code: 2516, name: "Namibia", iso: "NA" },
  { code: 2520, name: "Nauru", iso: "NR" },
  { code: 2524, name: "Nepal", iso: "NP" },
  { code: 2528, name: "Netherlands", iso: "NL" },
  { code: 2540, name: "New Caledonia", iso: "NC" },
  { code: 2554, name: "New Zealand", iso: "NZ" },
  { code: 2558, name: "Nicaragua", iso: "NI" },
  { code: 2562, name: "Niger", iso: "NE" },
  { code: 2566, name: "Nigeria", iso: "NG" },
  { code: 2570, name: "Niue", iso: "NU" },
  { code: 2574, name: "Norfolk Island", iso: "NF" },
  { code: 2807, name: "North Macedonia", iso: "MK" },
  { code: 2580, name: "Northern Mariana Islands", iso: "MP" },
  { code: 2578, name: "Norway", iso: "NO" },
  { code: 2512, name: "Oman", iso: "OM" },
  { code: 2586, name: "Pakistan", iso: "PK" },
  { code: 2585, name: "Palau", iso: "PW" },
  { code: 2591, name: "Panama", iso: "PA" },
  { code: 2598, name: "Papua New Guinea", iso: "PG" },
  { code: 2600, name: "Paraguay", iso: "PY" },
  { code: 2604, name: "Peru", iso: "PE" },
  { code: 2608, name: "Philippines", iso: "PH" },
  { code: 2612, name: "Pitcairn Islands", iso: "PN" },
  { code: 2616, name: "Poland", iso: "PL" },
  { code: 2620, name: "Portugal", iso: "PT" },
  { code: 2634, name: "Qatar", iso: "QA" },
  { code: 2178, name: "Republic of the Congo", iso: "CG" },
  { code: 2642, name: "Romania", iso: "RO" },
  { code: 2646, name: "Rwanda", iso: "RW" },
  { code: 2654, name: "Saint Helena, Ascension and Tristan da Cunha", iso: "SH" },
  { code: 2659, name: "Saint Kitts and Nevis", iso: "KN" },
  { code: 2662, name: "Saint Lucia", iso: "LC" },
  { code: 2666, name: "Saint Pierre and Miquelon", iso: "PM" },
  { code: 2670, name: "Saint Vincent and the Grenadines", iso: "VC" },
  { code: 2882, name: "Samoa", iso: "WS" },
  { code: 2674, name: "San Marino", iso: "SM" },
  { code: 2678, name: "Sao Tome and Principe", iso: "ST" },
  { code: 2682, name: "Saudi Arabia", iso: "SA" },
  { code: 2686, name: "Senegal", iso: "SN" },
  { code: 2688, name: "Serbia", iso: "RS" },
  { code: 2690, name: "Seychelles", iso: "SC" },
  { code: 2694, name: "Sierra Leone", iso: "SL" },
  { code: 2702, name: "Singapore", iso: "SG" },
  { code: 2534, name: "Sint Maarten", iso: "SX" },
  { code: 2703, name: "Slovakia", iso: "SK" },
  { code: 2705, name: "Slovenia", iso: "SI" },
  { code: 2090, name: "Solomon Islands", iso: "SB" },
  { code: 2706, name: "Somalia", iso: "SO" },
  { code: 2710, name: "South Africa", iso: "ZA" },
  { code: 2239, name: "South Georgia and the South Sandwich Islands", iso: "GS" },
  { code: 2410, name: "South Korea", iso: "KR" },
  { code: 2724, name: "Spain", iso: "ES" },
  { code: 2144, name: "Sri Lanka", iso: "LK" },
  { code: 2740, name: "Suriname", iso: "SR" },
  { code: 2752, name: "Sweden", iso: "SE" },
  { code: 2756, name: "Switzerland", iso: "CH" },
  { code: 2762, name: "Tajikistan", iso: "TJ" },
  { code: 2834, name: "Tanzania", iso: "TZ" },
  { code: 2764, name: "Thailand", iso: "TH" },
  { code: 2044, name: "The Bahamas", iso: "BS" },
  { code: 2270, name: "The Gambia", iso: "GM" },
  { code: 2626, name: "Timor-Leste", iso: "TL" },
  { code: 2768, name: "Togo", iso: "TG" },
  { code: 2772, name: "Tokelau", iso: "TK" },
  { code: 2776, name: "Tonga", iso: "TO" },
  { code: 2780, name: "Trinidad and Tobago", iso: "TT" },
  { code: 2788, name: "Tunisia", iso: "TN" },
  { code: 2792, name: "Turkiye", iso: "TR" },
  { code: 2795, name: "Turkmenistan", iso: "TM" },
  { code: 2798, name: "Tuvalu", iso: "TV" },
  { code: 2800, name: "Uganda", iso: "UG" },
  { code: 2804, name: "Ukraine", iso: "UA" },
  { code: 2784, name: "United Arab Emirates", iso: "AE" },
  { code: 2826, name: "United Kingdom", iso: "GB" },
  { code: 2840, name: "United States", iso: "US" },
  { code: 2581, name: "United States Minor Outlying Islands", iso: "UM" },
  { code: 2858, name: "Uruguay", iso: "UY" },
  { code: 2860, name: "Uzbekistan", iso: "UZ" },
  { code: 2548, name: "Vanuatu", iso: "VU" },
  { code: 2336, name: "Vatican City", iso: "VA" },
  { code: 2862, name: "Venezuela", iso: "VE" },
  { code: 2704, name: "Vietnam", iso: "VN" },
  { code: 2876, name: "Wallis and Futuna", iso: "WF" },
  { code: 2887, name: "Yemen", iso: "YE" },
  { code: 2894, name: "Zambia", iso: "ZM" },
  { code: 2716, name: "Zimbabwe", iso: "ZW" }
];

export const GEO_REGIONS: GeoRegion[] = [
  { code: 9075384, name: "Andorra la Vella", full: "Andorra la Vella,Andorra", iso: "AD" },
  { code: 9075379, name: "Canillo", full: "Canillo,Andorra", iso: "AD" },
  { code: 9075380, name: "Encamp", full: "Encamp,Andorra", iso: "AD" },
  { code: 9075383, name: "Escaldes-Engordany", full: "Escaldes-Engordany,Andorra", iso: "AD" },
  { code: 9075381, name: "La Massana", full: "La Massana,Andorra", iso: "AD" },
  { code: 9075382, name: "Ordino", full: "Ordino,Andorra", iso: "AD" },
  { code: 9075385, name: "Sant Julia de Loria", full: "Sant Julia de Loria,Andorra", iso: "AD" },
  { code: 9075415, name: "Saint George", full: "Saint George,Antigua and Barbuda", iso: "AG" },
  { code: 9075418, name: "Saint John", full: "Saint John,Antigua and Barbuda", iso: "AG" },
  { code: 9075416, name: "Saint Mary", full: "Saint Mary,Antigua and Barbuda", iso: "AG" },
  { code: 9075414, name: "Saint Paul", full: "Saint Paul,Antigua and Barbuda", iso: "AG" },
  { code: 9075413, name: "Saint Peter", full: "Saint Peter,Antigua and Barbuda", iso: "AG" },
  { code: 9075417, name: "Saint Philip", full: "Saint Philip,Antigua and Barbuda", iso: "AG" },
  { code: 2660, name: "Anguilla", full: "Anguilla", iso: "AI" },
  { code: 20042, name: "Burgenland", full: "Burgenland,Austria", iso: "AT" },
  { code: 20043, name: "Carinthia", full: "Carinthia,Austria", iso: "AT" },
  { code: 20044, name: "Lower Austria", full: "Lower Austria,Austria", iso: "AT" },
  { code: 20046, name: "Salzburg", full: "Salzburg,Austria", iso: "AT" },
  { code: 20047, name: "Styria", full: "Styria,Austria", iso: "AT" },
  { code: 20048, name: "Tyrol", full: "Tyrol,Austria", iso: "AT" },
  { code: 20045, name: "Upper Austria", full: "Upper Austria,Austria", iso: "AT" },
  { code: 20050, name: "Vienna", full: "Vienna,Austria", iso: "AT" },
  { code: 20049, name: "Vorarlberg", full: "Vorarlberg,Austria", iso: "AT" },
  { code: 20034, name: "Australian Capital Territory", full: "Australian Capital Territory,Australia", iso: "AU" },
  { code: 9112833, name: "Falls Creek Alpine Resort (Unincorporated)", full: "Falls Creek Alpine Resort (Unincorporated),Victoria,Australia", iso: "AU" },
  { code: 9112727, name: "Lake Mountain Alpine Resort (Unincorporated)", full: "Lake Mountain Alpine Resort (Unincorporated),Victoria,Australia", iso: "AU" },
  { code: 9112526, name: "Mount Baw Baw Alpine Resort (Unincorporated)", full: "Mount Baw Baw Alpine Resort (Unincorporated),Victoria,Australia", iso: "AU" },
  { code: 9112778, name: "Mount Stirling Alpine Resort (Unincorporated)", full: "Mount Stirling Alpine Resort (Unincorporated),Victoria,Australia", iso: "AU" },
  { code: 20035, name: "New South Wales", full: "New South Wales,Australia", iso: "AU" },
  { code: 9112558, name: "Nhulunbuy", full: "Nhulunbuy,Northern Territory,Australia", iso: "AU" },
  { code: 9112688, name: "Northern Territory Rates Act Area", full: "Northern Territory Rates Act Area,Northern Territory,Australia", iso: "AU" },
  { code: 20036, name: "Northern Territory", full: "Northern Territory,Australia", iso: "AU" },
  { code: 20037, name: "Queensland", full: "Queensland,Australia", iso: "AU" },
  { code: 20038, name: "South Australia", full: "South Australia,Australia", iso: "AU" },
  { code: 20039, name: "Tasmania", full: "Tasmania,Australia", iso: "AU" },
  { code: 9112835, name: "Un-Incorporated (Elrundie) Area", full: "Un-Incorporated (Elrundie) Area,Northern Territory,Australia", iso: "AU" },
  { code: 20040, name: "Victoria", full: "Victoria,Australia", iso: "AU" },
  { code: 20041, name: "Western Australia", full: "Western Australia,Australia", iso: "AU" },
  { code: 9112795, name: "Yulara", full: "Yulara,Northern Territory,Australia", iso: "AU" },
  { code: 2533, name: "Aruba", full: "Aruba", iso: "AW" },
  { code: 9070386, name: "Nakhchivan Autonomous Republic", full: "Nakhchivan Autonomous Republic,Azerbaijan", iso: "AZ" },
  { code: 20079, name: "Republika Srpska", full: "Republika Srpska,Bosnia and Herzegovina", iso: "BA" },
  { code: 9073536, name: "Mymensingh Division", full: "Mymensingh Division,Bangladesh", iso: "BD" },
  { code: 9069523, name: "Flanders", full: "Flanders,Belgium", iso: "BE" },
  { code: 9069524, name: "Wallonia", full: "Wallonia,Belgium", iso: "BE" },
  { code: 9070248, name: "Boucle du Mouhoun Region", full: "Boucle du Mouhoun Region,Burkina Faso", iso: "BF" },
  { code: 9070250, name: "Cascades Region", full: "Cascades Region,Burkina Faso", iso: "BF" },
  { code: 9070247, name: "Centre Region", full: "Centre Region,Burkina Faso", iso: "BF" },
  { code: 9070254, name: "Centre-Est Region", full: "Centre-Est Region,Burkina Faso", iso: "BF" },
  { code: 9075429, name: "Centre-Nord Region", full: "Centre-Nord Region,Burkina Faso", iso: "BF" },
  { code: 9070251, name: "Centre-Ouest Region", full: "Centre-Ouest Region,Burkina Faso", iso: "BF" },
  { code: 9075427, name: "Centre-Sud Region", full: "Centre-Sud Region,Burkina Faso", iso: "BF" },
  { code: 9070255, name: "Est Region", full: "Est Region,Burkina Faso", iso: "BF" },
  { code: 9070249, name: "Hauts-Bassins Region", full: "Hauts-Bassins Region,Burkina Faso", iso: "BF" },
  { code: 9070252, name: "Nord Region", full: "Nord Region,Burkina Faso", iso: "BF" },
  { code: 9075428, name: "Plateau-Central Region", full: "Plateau-Central Region,Burkina Faso", iso: "BF" },
  { code: 9070253, name: "Sahel Region", full: "Sahel Region,Burkina Faso", iso: "BF" },
  { code: 9070246, name: "Sud-Ouest Region", full: "Sud-Ouest Region,Burkina Faso", iso: "BF" },
  { code: 2060, name: "Bermuda", full: "Bermuda", iso: "BM" },
  { code: 9070169, name: "Devonshire Parish", full: "Devonshire Parish,Bermuda", iso: "BM" },
  { code: 9070448, name: "Hamilton Parish", full: "Hamilton Parish,Bermuda", iso: "BM" },
  { code: 9070171, name: "Paget Parish", full: "Paget Parish,Bermuda", iso: "BM" },
  { code: 9070168, name: "Pembroke Parish", full: "Pembroke Parish,Bermuda", iso: "BM" },
  { code: 9070170, name: "Sandys Parish", full: "Sandys Parish,Bermuda", iso: "BM" },
  { code: 9070167, name: "Smiths Parish", full: "Smiths Parish,Bermuda", iso: "BM" },
  { code: 9070173, name: "Southampton Parish", full: "Southampton Parish,Bermuda", iso: "BM" },
  { code: 9070174, name: "St. George's Parish", full: "St. George's Parish,Bermuda", iso: "BM" },
  { code: 9070172, name: "Warwick Parish", full: "Warwick Parish,Bermuda", iso: "BM" },
  { code: 20090, name: "Federal District", full: "Federal District,Brazil", iso: "BR" },
  { code: 21232, name: "State of Acre", full: "State of Acre,Brazil", iso: "BR" },
  { code: 20086, name: "State of Alagoas", full: "State of Alagoas,Brazil", iso: "BR" },
  { code: 21226, name: "State of Amapa", full: "State of Amapa,Brazil", iso: "BR" },
  { code: 20087, name: "State of Amazonas", full: "State of Amazonas,Brazil", iso: "BR" },
  { code: 20088, name: "State of Bahia", full: "State of Bahia,Brazil", iso: "BR" },
  { code: 20089, name: "State of Ceara", full: "State of Ceara,Brazil", iso: "BR" },
  { code: 20091, name: "State of Espirito Santo", full: "State of Espirito Santo,Brazil", iso: "BR" },
  { code: 20092, name: "State of Goias", full: "State of Goias,Brazil", iso: "BR" },
  { code: 20093, name: "State of Maranhao", full: "State of Maranhao,Brazil", iso: "BR" },
  { code: 20095, name: "State of Mato Grosso do Sul", full: "State of Mato Grosso do Sul,Brazil", iso: "BR" },
  { code: 20096, name: "State of Mato Grosso", full: "State of Mato Grosso,Brazil", iso: "BR" },
  { code: 20094, name: "State of Minas Gerais", full: "State of Minas Gerais,Brazil", iso: "BR" },
  { code: 20097, name: "State of Para", full: "State of Para,Brazil", iso: "BR" },
  { code: 20098, name: "State of Paraiba", full: "State of Paraiba,Brazil", iso: "BR" },
  { code: 20101, name: "State of Parana", full: "State of Parana,Brazil", iso: "BR" },
  { code: 20099, name: "State of Pernambuco", full: "State of Pernambuco,Brazil", iso: "BR" },
  { code: 20100, name: "State of Piaui", full: "State of Piaui,Brazil", iso: "BR" },
  { code: 20103, name: "State of Rio Grande do Norte", full: "State of Rio Grande do Norte,Brazil", iso: "BR" },
  { code: 20104, name: "State of Rio Grande do Sul", full: "State of Rio Grande do Sul,Brazil", iso: "BR" },
  { code: 20102, name: "State of Rio de Janeiro", full: "State of Rio de Janeiro,Brazil", iso: "BR" },
  { code: 21227, name: "State of Rondonia", full: "State of Rondonia,Brazil", iso: "BR" },
  { code: 21228, name: "State of Roraima", full: "State of Roraima,Brazil", iso: "BR" },
  { code: 20105, name: "State of Santa Catarina", full: "State of Santa Catarina,Brazil", iso: "BR" },
  { code: 20106, name: "State of Sao Paulo", full: "State of Sao Paulo,Brazil", iso: "BR" },
  { code: 21229, name: "State of Sergipe", full: "State of Sergipe,Brazil", iso: "BR" },
  { code: 21230, name: "State of Tocantins", full: "State of Tocantins,Brazil", iso: "BR" },
  { code: 2074, name: "Bouvet Island", full: "Bouvet Island", iso: "BV" },
  { code: 20152, name: "Antofagasta", full: "Antofagasta,Chile", iso: "CL" },
  { code: 20153, name: "Araucania", full: "Araucania,Chile", iso: "CL" },
  { code: 9047103, name: "Arica y Parinacota", full: "Arica y Parinacota,Chile", iso: "CL" },
  { code: 9047104, name: "Atacama", full: "Atacama,Chile", iso: "CL" },
  { code: 9047102, name: "Aysen", full: "Aysen,Chile", iso: "CL" },
  { code: 20154, name: "Bio Bio", full: "Bio Bio,Chile", iso: "CL" },
  { code: 20155, name: "Coquimbo", full: "Coquimbo,Chile", iso: "CL" },
  { code: 20157, name: "Los Lagos", full: "Los Lagos,Chile", iso: "CL" },
  { code: 9047105, name: "Los Rios", full: "Los Rios,Chile", iso: "CL" },
  { code: 20158, name: "Magallanes and Chilean Antarctica", full: "Magallanes and Chilean Antarctica,Chile", iso: "CL" },
  { code: 20159, name: "Maule", full: "Maule,Chile", iso: "CL" },
  { code: 9099772, name: "Nuble", full: "Nuble,Chile", iso: "CL" },
  { code: 20156, name: "O'Higgins", full: "O'Higgins,Chile", iso: "CL" },
  { code: 20160, name: "Santiago Metropolitan Region", full: "Santiago Metropolitan Region,Chile", iso: "CL" },
  { code: 20161, name: "Tarapaca", full: "Tarapaca,Chile", iso: "CL" },
  { code: 20162, name: "Valparaiso", full: "Valparaiso,Chile", iso: "CL" },
  { code: 9075465, name: "Adamawa", full: "Adamawa,Cameroon", iso: "CM" },
  { code: 9070075, name: "Centre", full: "Centre,Cameroon", iso: "CM" },
  { code: 9070074, name: "East", full: "East,Cameroon", iso: "CM" },
  { code: 9070426, name: "Far North", full: "Far North,Cameroon", iso: "CM" },
  { code: 9070073, name: "Littoral", full: "Littoral,Cameroon", iso: "CM" },
  { code: 9070078, name: "North", full: "North,Cameroon", iso: "CM" },
  { code: 9070077, name: "Northwest", full: "Northwest,Cameroon", iso: "CM" },
  { code: 9070079, name: "South", full: "South,Cameroon", iso: "CM" },
  { code: 9070076, name: "Southwest", full: "Southwest,Cameroon", iso: "CM" },
  { code: 9070072, name: "West", full: "West,Cameroon", iso: "CM" },
  { code: 20174, name: "Anhui", full: "Anhui,China", iso: "CN" },
  { code: 20163, name: "Beijing", full: "Beijing,China", iso: "CN" },
  { code: 20184, name: "Chongqing", full: "Chongqing,China", iso: "CN" },
  { code: 20175, name: "Fujian", full: "Fujian,China", iso: "CN" },
  { code: 20190, name: "Gansu", full: "Gansu,China", iso: "CN" },
  { code: 20181, name: "Guangdong Province", full: "Guangdong Province,China", iso: "CN" },
  { code: 20182, name: "Guangxi", full: "Guangxi,China", iso: "CN" },
  { code: 20186, name: "Guizhou", full: "Guizhou,China", iso: "CN" },
  { code: 20183, name: "Hainan", full: "Hainan,China", iso: "CN" },
  { code: 20165, name: "Hebei", full: "Hebei,China", iso: "CN" },
  { code: 20170, name: "Heilongjiang", full: "Heilongjiang,China", iso: "CN" },
  { code: 20178, name: "Henan", full: "Henan,China", iso: "CN" },
  { code: 20179, name: "Hubei", full: "Hubei,China", iso: "CN" },
  { code: 20180, name: "Hunan", full: "Hunan,China", iso: "CN" },
  { code: 20167, name: "Inner Mongolia", full: "Inner Mongolia,China", iso: "CN" },
  { code: 20172, name: "Jiangsu", full: "Jiangsu,China", iso: "CN" },
  { code: 20176, name: "Jiangxi", full: "Jiangxi,China", iso: "CN" },
  { code: 20169, name: "Jilin", full: "Jilin,China", iso: "CN" },
  { code: 20168, name: "Liaoning", full: "Liaoning,China", iso: "CN" },
  { code: 20192, name: "Ningxia", full: "Ningxia,China", iso: "CN" },
  { code: 20191, name: "Qinghai", full: "Qinghai,China", iso: "CN" },
  { code: 20189, name: "Shaanxi", full: "Shaanxi,China", iso: "CN" },
  { code: 20177, name: "Shandong", full: "Shandong,China", iso: "CN" },
  { code: 20171, name: "Shanghai", full: "Shanghai,China", iso: "CN" },
  { code: 20166, name: "Shanxi", full: "Shanxi,China", iso: "CN" },
  { code: 20185, name: "Sichuan", full: "Sichuan,China", iso: "CN" },
  { code: 20164, name: "Tianjin", full: "Tianjin,China", iso: "CN" },
  { code: 20188, name: "Tibet", full: "Tibet,China", iso: "CN" },
  { code: 20193, name: "Xinjiang", full: "Xinjiang,China", iso: "CN" },
  { code: 20187, name: "Yunnan", full: "Yunnan,China", iso: "CN" },
  { code: 20173, name: "Zhejiang", full: "Zhejiang,China", iso: "CN" },
  { code: 21506, name: "Amazonas", full: "Amazonas,Colombia", iso: "CO" },
  { code: 20198, name: "Antioquia", full: "Antioquia,Colombia", iso: "CO" },
  { code: 21507, name: "Arauca", full: "Arauca,Colombia", iso: "CO" },
  { code: 20199, name: "Atlantico", full: "Atlantico,Colombia", iso: "CO" },
  { code: 20203, name: "Bogota", full: "Bogota,Colombia", iso: "CO" },
  { code: 20200, name: "Bolivar", full: "Bolivar,Colombia", iso: "CO" },
  { code: 21508, name: "Boyaca", full: "Boyaca,Colombia", iso: "CO" },
  { code: 20201, name: "Caldas", full: "Caldas,Colombia", iso: "CO" },
  { code: 21509, name: "Caqueta", full: "Caqueta,Colombia", iso: "CO" },
  { code: 21510, name: "Casanare", full: "Casanare,Colombia", iso: "CO" },
  { code: 21511, name: "Cauca", full: "Cauca,Colombia", iso: "CO" },
  { code: 21512, name: "Cesar", full: "Cesar,Colombia", iso: "CO" },
  { code: 21513, name: "Choco", full: "Choco,Colombia", iso: "CO" },
  { code: 21514, name: "Cordoba", full: "Cordoba,Colombia", iso: "CO" },
  { code: 20202, name: "Cundinamarca", full: "Cundinamarca,Colombia", iso: "CO" },
  { code: 21515, name: "Guainia", full: "Guainia,Colombia", iso: "CO" },
  { code: 21516, name: "Guaviare", full: "Guaviare,Colombia", iso: "CO" },
  { code: 20204, name: "Huila", full: "Huila,Colombia", iso: "CO" },
  { code: 21517, name: "La Guajira", full: "La Guajira,Colombia", iso: "CO" },
  { code: 21290, name: "Magdalena", full: "Magdalena,Colombia", iso: "CO" },
  { code: 20205, name: "Meta", full: "Meta,Colombia", iso: "CO" },
  { code: 20206, name: "Narino", full: "Narino,Colombia", iso: "CO" },
  { code: 21518, name: "North Santander", full: "North Santander,Colombia", iso: "CO" },
  { code: 20207, name: "Putumayo", full: "Putumayo,Colombia", iso: "CO" },
  { code: 21519, name: "Quindio", full: "Quindio,Colombia", iso: "CO" },
  { code: 20208, name: "Risaralda", full: "Risaralda,Colombia", iso: "CO" },
  { code: 21520, name: "San Andres and Providencia", full: "San Andres and Providencia,Colombia", iso: "CO" },
  { code: 20209, name: "Santander", full: "Santander,Colombia", iso: "CO" },
  { code: 21521, name: "Sucre", full: "Sucre,Colombia", iso: "CO" },
  { code: 20210, name: "Tolima", full: "Tolima,Colombia", iso: "CO" },
  { code: 20211, name: "Valle del Cauca", full: "Valle del Cauca,Colombia", iso: "CO" },
  { code: 21522, name: "Vaupes", full: "Vaupes,Colombia", iso: "CO" },
  { code: 21523, name: "Vichada", full: "Vichada,Colombia", iso: "CO" },
  { code: 21494, name: "Central Bohemian Region", full: "Central Bohemian Region,Czechia", iso: "CZ" },
  { code: 21495, name: "Hradec Kralove Region", full: "Hradec Kralove Region,Czechia", iso: "CZ" },
  { code: 21496, name: "Karlovy Vary Region", full: "Karlovy Vary Region,Czechia", iso: "CZ" },
  { code: 21497, name: "Liberec Region", full: "Liberec Region,Czechia", iso: "CZ" },
  { code: 21498, name: "Moravian-Silesian Region", full: "Moravian-Silesian Region,Czechia", iso: "CZ" },
  { code: 21499, name: "Olomouc Region", full: "Olomouc Region,Czechia", iso: "CZ" },
  { code: 21500, name: "Pardubice Region", full: "Pardubice Region,Czechia", iso: "CZ" },
  { code: 21501, name: "Plzen Region", full: "Plzen Region,Czechia", iso: "CZ" },
  { code: 21502, name: "Prague", full: "Prague,Czechia", iso: "CZ" },
  { code: 20218, name: "South Bohemian Region", full: "South Bohemian Region,Czechia", iso: "CZ" },
  { code: 20219, name: "South Moravian Region", full: "South Moravian Region,Czechia", iso: "CZ" },
  { code: 21503, name: "Usti nad Labem Region", full: "Usti nad Labem Region,Czechia", iso: "CZ" },
  { code: 21504, name: "Vysocina Region", full: "Vysocina Region,Czechia", iso: "CZ" },
  { code: 21505, name: "Zlin Region", full: "Zlin Region,Czechia", iso: "CZ" },
  { code: 20228, name: "Baden-Wurttemberg", full: "Baden-Wurttemberg,Germany", iso: "DE" },
  { code: 20229, name: "Bavaria", full: "Bavaria,Germany", iso: "DE" },
  { code: 20226, name: "Berlin", full: "Berlin,Germany", iso: "DE" },
  { code: 20227, name: "Brandenburg", full: "Brandenburg,Germany", iso: "DE" },
  { code: 20230, name: "Bremen", full: "Bremen,Germany", iso: "DE" },
  { code: 20232, name: "Hamburg", full: "Hamburg,Germany", iso: "DE" },
  { code: 20231, name: "Hessen", full: "Hessen,Germany", iso: "DE" },
  { code: 20234, name: "Lower Saxony", full: "Lower Saxony,Germany", iso: "DE" },
  { code: 20233, name: "Mecklenburg-Vorpommern", full: "Mecklenburg-Vorpommern,Germany", iso: "DE" },
  { code: 20235, name: "North Rhine-Westphalia", full: "North Rhine-Westphalia,Germany", iso: "DE" },
  { code: 20236, name: "Rhineland-Palatinate", full: "Rhineland-Palatinate,Germany", iso: "DE" },
  { code: 20238, name: "Saarland", full: "Saarland,Germany", iso: "DE" },
  { code: 20239, name: "Saxony", full: "Saxony,Germany", iso: "DE" },
  { code: 20240, name: "Saxony-Anhalt", full: "Saxony-Anhalt,Germany", iso: "DE" },
  { code: 20237, name: "Schleswig-Holstein", full: "Schleswig-Holstein,Germany", iso: "DE" },
  { code: 20241, name: "Thuringia", full: "Thuringia,Germany", iso: "DE" },
  { code: 9075482, name: "Arta", full: "Arta,Djibouti", iso: "DJ" },
  { code: 9075483, name: "Djibouti", full: "Djibouti,Djibouti", iso: "DJ" },
  { code: 20243, name: "Capital Region of Denmark", full: "Capital Region of Denmark,Denmark", iso: "DK" },
  { code: 20254, name: "Central Denmark Region", full: "Central Denmark Region,Denmark", iso: "DK" },
  { code: 20256, name: "North Denmark Region", full: "North Denmark Region,Denmark", iso: "DK" },
  { code: 20245, name: "Region Zealand", full: "Region Zealand,Denmark", iso: "DK" },
  { code: 20252, name: "Region of Southern Denmark", full: "Region of Southern Denmark,Denmark", iso: "DK" },
  { code: 9112353, name: "Qalyub", full: "Qalyub,Al Qalyubia Governorate,Egypt", iso: "EG" },
  { code: 9112367, name: "Tura", full: "Tura,Cairo Governorate,Egypt", iso: "EG" },
  { code: 9070455, name: "Guelmim-Es Semara", full: "Guelmim-Es Semara,Western Sahara", iso: "EH" },
  { code: 9070280, name: "Oued Ed-Dahab-Lagouira", full: "Oued Ed-Dahab-Lagouira,Western Sahara", iso: "EH" },
  { code: 2732, name: "Western Sahara", full: "Western Sahara", iso: "EH" },
  { code: 9075489, name: "Central", full: "Central,Eritrea", iso: "ER" },
  { code: 9075490, name: "Southern Red Sea", full: "Southern Red Sea,Eritrea", iso: "ER" },
  { code: 9075496, name: "Afar", full: "Afar,Ethiopia", iso: "ET" },
  { code: 9075493, name: "Amhara", full: "Amhara,Ethiopia", iso: "ET" },
  { code: 9075492, name: "Benishangul-Gumuz", full: "Benishangul-Gumuz,Ethiopia", iso: "ET" },
  { code: 9075495, name: "Oromia", full: "Oromia,Ethiopia", iso: "ET" },
  { code: 9075497, name: "Somali", full: "Somali,Ethiopia", iso: "ET" },
  { code: 9075494, name: "Southern Nations", full: "Southern Nations, Nationalities, and People's Region,Ethiopia", iso: "ET" },
  { code: 9075491, name: "Tigray", full: "Tigray,Ethiopia", iso: "ET" },
  { code: 9075507, name: "Central Finland", full: "Central Finland,Finland", iso: "FI" },
  { code: 9075500, name: "Central Ostrobothnia", full: "Central Ostrobothnia,Finland", iso: "FI" },
  { code: 9075513, name: "Kainuu", full: "Kainuu,Finland", iso: "FI" },
  { code: 9075515, name: "Kymenlaakso", full: "Kymenlaakso,Finland", iso: "FI" },
  { code: 9075508, name: "Lapland", full: "Lapland,Finland", iso: "FI" },
  { code: 9075510, name: "North Karelia", full: "North Karelia,Finland", iso: "FI" },
  { code: 9075509, name: "North Savo", full: "North Savo,Finland", iso: "FI" },
  { code: 9075514, name: "Northern Ostrobothnia", full: "Northern Ostrobothnia,Finland", iso: "FI" },
  { code: 9075504, name: "Ostrobothnia", full: "Ostrobothnia,Finland", iso: "FI" },
  { code: 9075516, name: "Paijanne Tavastia", full: "Paijanne Tavastia,Finland", iso: "FI" },
  { code: 9075505, name: "Pirkanmaa", full: "Pirkanmaa,Finland", iso: "FI" },
  { code: 9075502, name: "Satakunta", full: "Satakunta,Finland", iso: "FI" },
  { code: 9075511, name: "South Karelia", full: "South Karelia,Finland", iso: "FI" },
  { code: 9075517, name: "South Savo", full: "South Savo,Finland", iso: "FI" },
  { code: 9075512, name: "Southern Ostrobothnia", full: "Southern Ostrobothnia,Finland", iso: "FI" },
  { code: 9075501, name: "Southwest Finland", full: "Southwest Finland,Finland", iso: "FI" },
  { code: 9075503, name: "Tavastia Proper", full: "Tavastia Proper,Finland", iso: "FI" },
  { code: 9075506, name: "Uusimaa", full: "Uusimaa,Finland", iso: "FI" },
  { code: 2238, name: "Falkland Islands (Islas Malvinas)", full: "Falkland Islands (Islas Malvinas)", iso: "FK" },
  { code: 2234, name: "Faroe Islands", full: "Faroe Islands", iso: "FO" },
  { code: 20311, name: "Alsace", full: "Alsace,Grand Est,France", iso: "FR" },
  { code: 20313, name: "Aquitaine", full: "Aquitaine,Nouvelle-Aquitaine,France", iso: "FR" },
  { code: 20314, name: "Auvergne", full: "Auvergne,Auvergne-Rhone-Alpes,France", iso: "FR" },
  { code: 9069525, name: "Auvergne-Rhone-Alpes", full: "Auvergne-Rhone-Alpes,France", iso: "FR" },
  { code: 9068895, name: "Bourgogne-Franche-Comte", full: "Bourgogne-Franche-Comte,France", iso: "FR" },
  { code: 20316, name: "Brittany", full: "Brittany,France", iso: "FR" },
  { code: 20315, name: "Burgundy", full: "Burgundy,Bourgogne-Franche-Comte,France", iso: "FR" },
  { code: 20317, name: "Centre-Val de Loire", full: "Centre-Val de Loire,France", iso: "FR" },
  { code: 20318, name: "Champagne-Ardenne", full: "Champagne-Ardenne,Grand Est,France", iso: "FR" },
  { code: 20319, name: "Corsica", full: "Corsica,France", iso: "FR" },
  { code: 20320, name: "Franche-Comte", full: "Franche-Comte,Bourgogne-Franche-Comte,France", iso: "FR" },
  { code: 9068896, name: "Grand Est", full: "Grand Est,France", iso: "FR" },
  { code: 9068898, name: "Hauts-de-France", full: "Hauts-de-France,France", iso: "FR" },
  { code: 20321, name: "Ile-de-France", full: "Ile-de-France,France", iso: "FR" },
  { code: 20322, name: "Languedoc-Roussillon", full: "Languedoc-Roussillon,Occitanie,France", iso: "FR" },
  { code: 20323, name: "Limousin", full: "Limousin,Nouvelle-Aquitaine,France", iso: "FR" },
  { code: 20324, name: "Lorraine", full: "Lorraine,Grand Est,France", iso: "FR" },
  { code: 20327, name: "Lower Normandy", full: "Lower Normandy,Normandy,France", iso: "FR" },
  { code: 20325, name: "Midi-Pyrenees", full: "Midi-Pyrenees,Occitanie,France", iso: "FR" },
  { code: 20326, name: "Nord-Pas-de-Calais", full: "Nord-Pas-de-Calais,Hauts-de-France,France", iso: "FR" },
  { code: 9068565, name: "Normandy", full: "Normandy,France", iso: "FR" },
  { code: 9069522, name: "Nouvelle-Aquitaine", full: "Nouvelle-Aquitaine,France", iso: "FR" },
  { code: 9068897, name: "Occitanie", full: "Occitanie,France", iso: "FR" },
  { code: 20329, name: "Pays de la Loire", full: "Pays de la Loire,France", iso: "FR" },
  { code: 20330, name: "Picardy", full: "Picardy,Hauts-de-France,France", iso: "FR" },
  { code: 20331, name: "Poitou-Charentes", full: "Poitou-Charentes,Nouvelle-Aquitaine,France", iso: "FR" },
  { code: 20332, name: "Provence-Alpes-Cote d'Azur", full: "Provence-Alpes-Cote d'Azur,France", iso: "FR" },
  { code: 20333, name: "Rhone-Alpes", full: "Rhone-Alpes,Auvergne-Rhone-Alpes,France", iso: "FR" },
  { code: 20328, name: "Upper Normandy", full: "Upper Normandy,Normandy,France", iso: "FR" },
  { code: 9075531, name: "Carriacou and Petite Martinique", full: "Carriacou and Petite Martinique,Grenada", iso: "GD" },
  { code: 9075535, name: "Saint Andrew", full: "Saint Andrew,Grenada", iso: "GD" },
  { code: 9075534, name: "Saint David", full: "Saint David,Grenada", iso: "GD" },
  { code: 9075537, name: "Saint George", full: "Saint George,Grenada", iso: "GD" },
  { code: 9075532, name: "Saint John", full: "Saint John,Grenada", iso: "GD" },
  { code: 9075533, name: "Saint Mark", full: "Saint Mark,Grenada", iso: "GD" },
  { code: 9075536, name: "Saint Patrick", full: "Saint Patrick,Grenada", iso: "GD" },
  { code: 9069840, name: "Abkhazia", full: "Abkhazia,Georgia", iso: "GE" },
  { code: 9069842, name: "Adjara", full: "Adjara,Georgia", iso: "GE" },
  { code: 9069839, name: "Guria", full: "Guria,Georgia", iso: "GE" },
  { code: 9069844, name: "Imereti", full: "Imereti,Georgia", iso: "GE" },
  { code: 9069849, name: "Kakheti", full: "Kakheti,Georgia", iso: "GE" },
  { code: 9069848, name: "Kvemo Kartli", full: "Kvemo Kartli,Georgia", iso: "GE" },
  { code: 9069843, name: "Mtskheta-Mtianeti", full: "Mtskheta-Mtianeti,Georgia", iso: "GE" },
  { code: 9069847, name: "Racha-Lechkhumi and Lower Svaneti", full: "Racha-Lechkhumi and Lower Svaneti,Georgia", iso: "GE" },
  { code: 9069846, name: "Samegrelo-Zemo Svaneti", full: "Samegrelo-Zemo Svaneti,Georgia", iso: "GE" },
  { code: 9069845, name: "Samtskhe-Javakheti", full: "Samtskhe-Javakheti,Georgia", iso: "GE" },
  { code: 9069838, name: "Shida Kartli", full: "Shida Kartli,Georgia", iso: "GE" },
  { code: 9069841, name: "Tbilisi", full: "Tbilisi,Georgia", iso: "GE" },
  { code: 2254, name: "French Guiana", full: "French Guiana", iso: "GF" },
  { code: 9075548, name: "Castel", full: "Castel,Guernsey", iso: "GG" },
  { code: 9075542, name: "Forest", full: "Forest,Guernsey", iso: "GG" },
  { code: 9075545, name: "Saint Saviour", full: "Saint Saviour,Guernsey", iso: "GG" },
  { code: 9075547, name: "St Andrew", full: "St Andrew,Guernsey", iso: "GG" },
  { code: 9075540, name: "St Martin", full: "St Martin,Guernsey", iso: "GG" },
  { code: 9075544, name: "St Pierre Du Bois", full: "St Pierre Du Bois,Guernsey", iso: "GG" },
  { code: 9075543, name: "St Sampson", full: "St Sampson,Guernsey", iso: "GG" },
  { code: 9075541, name: "Torteval", full: "Torteval,Guernsey", iso: "GG" },
  { code: 9075546, name: "Vale", full: "Vale,Guernsey", iso: "GG" },
  { code: 9069836, name: "Ashanti Region", full: "Ashanti Region,Ghana", iso: "GH" },
  { code: 9070372, name: "Brong Ahafo Region", full: "Brong Ahafo Region,Ghana", iso: "GH" },
  { code: 9070367, name: "Central Region", full: "Central Region,Ghana", iso: "GH" },
  { code: 9069834, name: "Eastern Region", full: "Eastern Region,Ghana", iso: "GH" },
  { code: 9069837, name: "Greater Accra Region", full: "Greater Accra Region,Ghana", iso: "GH" },
  { code: 9070369, name: "Northern Region", full: "Northern Region,Ghana", iso: "GH" },
  { code: 9070371, name: "Upper East Region", full: "Upper East Region,Ghana", iso: "GH" },
  { code: 9070370, name: "Upper West Region", full: "Upper West Region,Ghana", iso: "GH" },
  { code: 9070368, name: "Volta Region", full: "Volta Region,Ghana", iso: "GH" },
  { code: 9069835, name: "Western Region", full: "Western Region,Ghana", iso: "GH" },
  { code: 2292, name: "Gibraltar", full: "Gibraltar", iso: "GI" },
  { code: 2304, name: "Greenland", full: "Greenland", iso: "GL" },
  { code: 9075551, name: "Boke", full: "Boke,Guinea", iso: "GN" },
  { code: 9075549, name: "Conakry", full: "Conakry,Guinea", iso: "GN" },
  { code: 9075552, name: "Kankan", full: "Kankan,Guinea", iso: "GN" },
  { code: 9075550, name: "Labe", full: "Labe,Guinea", iso: "GN" },
  { code: 9070394, name: "Basse-Terre", full: "Basse-Terre,Guadeloupe", iso: "GP" },
  { code: 9069935, name: "Grande-Terre", full: "Grande-Terre,Guadeloupe", iso: "GP" },
  { code: 2312, name: "Guadeloupe", full: "Guadeloupe", iso: "GP" },
  { code: 20357, name: "Achaea", full: "Achaea,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067719, name: "Aetolia-Acarnania", full: "Aetolia-Acarnania,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067718, name: "Agrinio", full: "Agrinio,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067707, name: "Arcadia", full: "Arcadia,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067717, name: "Argolis", full: "Argolis,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 20366, name: "Arta", full: "Arta,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 9067710, name: "Aspropyrgos", full: "Aspropyrgos,Decentralized Administration of Attica,Greece", iso: "GR" },
  { code: 9067725, name: "Athens", full: "Athens,Decentralized Administration of Attica,Greece", iso: "GR" },
  { code: 9061582, name: "Attica", full: "Attica,Decentralized Administration of Attica,Greece", iso: "GR" },
  { code: 9061584, name: "Central Macedonia", full: "Central Macedonia,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067708, name: "Cephalonia", full: "Cephalonia,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 20397, name: "Chania", full: "Chania,Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 9067703, name: "Chios", full: "Chios,Decentralized Administration of the Aegean,Greece", iso: "GR" },
  { code: 20363, name: "Corfu", full: "Corfu,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067715, name: "Corinthia", full: "Corinthia,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9061581, name: "Crete", full: "Crete,Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 9069538, name: "Decentralized Administration of Attica", full: "Decentralized Administration of Attica,Greece", iso: "GR" },
  { code: 9069539, name: "Decentralized Administration of Crete", full: "Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 9075558, name: "Decentralized Administration of Epirus and Western Macedonia", full: "Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 9075557, name: "Decentralized Administration of Macedonia and Thrace", full: "Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9075556, name: "Decentralized Administration of Peloponnese", full: "Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9075559, name: "Decentralized Administration of Thessaly and Central Greece", full: "Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 9075555, name: "Decentralized Administration of the Aegean", full: "Decentralized Administration of the Aegean,Greece", iso: "GR" },
  { code: 20375, name: "Drama", full: "Drama,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067711, name: "Elis", full: "Elis,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 20352, name: "Euboea", full: "Euboea,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 9067712, name: "Evros", full: "Evros,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20384, name: "Florina", full: "Florina,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 9067701, name: "Grevena", full: "Grevena,Ipiros Ditiki Makedonia,Greece", iso: "GR" },
  { code: 9067706, name: "Halkidiki", full: "Halkidiki,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067723, name: "Heraklion", full: "Heraklion,Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 20376, name: "Imathia", full: "Imathia,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20368, name: "Ioannina", full: "Ioannina,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 20370, name: "Karditsa", full: "Karditsa,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 9067704, name: "Kastoria", full: "Kastoria,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 20378, name: "Kavala Prefecture", full: "Kavala Prefecture,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20380, name: "Kilkis", full: "Kilkis,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20381, name: "Kozani", full: "Kozani,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 20360, name: "Laconia", full: "Laconia,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067722, name: "Larissa", full: "Larissa,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 9067705, name: "Lasithi", full: "Lasithi,Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 20365, name: "Lefkada", full: "Lefkada,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 20391, name: "Lesbos", full: "Lesbos,Decentralized Administration of the Aegean,Greece", iso: "GR" },
  { code: 9067721, name: "Magnesia Prefecture", full: "Magnesia Prefecture,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 20361, name: "Messenia", full: "Messenia,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067714, name: "Pella", full: "Pella,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067702, name: "Phocis", full: "Phocis,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 20353, name: "Phthiotis", full: "Phthiotis,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 20369, name: "Preveza", full: "Preveza,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 9067724, name: "Rethymno", full: "Rethymno,Decentralized Administration of Crete,Greece", iso: "GR" },
  { code: 1007543, name: "Rhodes", full: "Rhodes,Decentralized Administration of the Aegean,Greece", iso: "GR" },
  { code: 20388, name: "Rhodope", full: "Rhodope,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20392, name: "Samos", full: "Samos,Decentralized Administration of the Aegean,Greece", iso: "GR" },
  { code: 9067713, name: "Serres", full: "Serres,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067709, name: "Thesprotia", full: "Thesprotia,Decentralized Administration of Epirus and Western Macedonia,Greece", iso: "GR" },
  { code: 9061583, name: "Thessalia", full: "Thessalia,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 20377, name: "Thessaloniki", full: "Thessaloniki,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 20373, name: "Trikala", full: "Trikala,Decentralized Administration of Thessaly and Central Greece,Greece", iso: "GR" },
  { code: 9061580, name: "Western Greece", full: "Western Greece,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9067720, name: "Xanthi", full: "Xanthi,Decentralized Administration of Macedonia and Thrace,Greece", iso: "GR" },
  { code: 9067716, name: "Zakynthos", full: "Zakynthos,Zakynthos,Decentralized Administration of Peloponnese, Western Greece and the Ionian,Greece", iso: "GR" },
  { code: 9075561, name: "Bafata", full: "Bafata,Guinea-Bissau", iso: "GW" },
  { code: 9075566, name: "Biombo", full: "Biombo,Guinea-Bissau", iso: "GW" },
  { code: 9075563, name: "Bissau", full: "Bissau,Guinea-Bissau", iso: "GW" },
  { code: 9075565, name: "Cacheu", full: "Cacheu,Guinea-Bissau", iso: "GW" },
  { code: 9075564, name: "Gabu", full: "Gabu,Guinea-Bissau", iso: "GW" },
  { code: 9075562, name: "Oio", full: "Oio,Guinea-Bissau", iso: "GW" },
  { code: 9075567, name: "Cuyuni-Mazaruni", full: "Cuyuni-Mazaruni,Guyana", iso: "GY" },
  { code: 9075571, name: "Demerara-Mahaica", full: "Demerara-Mahaica,Guyana", iso: "GY" },
  { code: 9075568, name: "East Berbice-Corentyne", full: "East Berbice-Corentyne,Guyana", iso: "GY" },
  { code: 9075572, name: "Essequibo Islands-West Demerara", full: "Essequibo Islands-West Demerara,Guyana", iso: "GY" },
  { code: 9075570, name: "Upper Demerara-Berbice", full: "Upper Demerara-Berbice,Guyana", iso: "GY" },
  { code: 9075569, name: "Upper Takutu-Upper Essequibo", full: "Upper Takutu-Upper Essequibo,Guyana", iso: "GY" },
  { code: 2344, name: "Hong Kong", full: "Hong Kong", iso: "HK" },
  { code: 9069536, name: "Kowloon", full: "Kowloon,Hong Kong", iso: "HK" },
  { code: 9069535, name: "New Territories", full: "New Territories,Hong Kong", iso: "HK" },
  { code: 20517, name: "Center District", full: "Center District,Israel", iso: "IL" },
  { code: 20515, name: "Haifa District", full: "Haifa District,Israel", iso: "IL" },
  { code: 20516, name: "Jerusalem District", full: "Jerusalem District,Israel", iso: "IL" },
  { code: 20519, name: "North District", full: "North District,Israel", iso: "IL" },
  { code: 20514, name: "South District", full: "South District,Israel", iso: "IL" },
  { code: 20518, name: "Tel Aviv District", full: "Tel Aviv District,Israel", iso: "IL" },
  { code: 20453, name: "Andhra Pradesh", full: "Andhra Pradesh,India", iso: "IN" },
  { code: 21289, name: "Arunachal Pradesh", full: "Arunachal Pradesh,India", iso: "IN" },
  { code: 20454, name: "Assam", full: "Assam,India", iso: "IN" },
  { code: 20455, name: "Bihar", full: "Bihar,India", iso: "IN" },
  { code: 21334, name: "Chhattisgarh", full: "Chhattisgarh,India", iso: "IN" },
  { code: 21268, name: "Goa", full: "Goa,India", iso: "IN" },
  { code: 20457, name: "Gujarat", full: "Gujarat,India", iso: "IN" },
  { code: 20458, name: "Haryana", full: "Haryana,India", iso: "IN" },
  { code: 21335, name: "Himachal Pradesh", full: "Himachal Pradesh,India", iso: "IN" },
  { code: 20459, name: "Jammu and Kashmir", full: "Jammu and Kashmir,India", iso: "IN" },
  { code: 21336, name: "Jharkhand", full: "Jharkhand,India", iso: "IN" },
  { code: 20460, name: "Karnataka", full: "Karnataka,India", iso: "IN" },
  { code: 20461, name: "Kerala", full: "Kerala,India", iso: "IN" },
  { code: 20464, name: "Madhya Pradesh", full: "Madhya Pradesh,India", iso: "IN" },
  { code: 20462, name: "Maharashtra", full: "Maharashtra,India", iso: "IN" },
  { code: 21337, name: "Manipur", full: "Manipur,India", iso: "IN" },
  { code: 20463, name: "Meghalaya", full: "Meghalaya,India", iso: "IN" },
  { code: 21338, name: "Mizoram", full: "Mizoram,India", iso: "IN" },
  { code: 21339, name: "Nagaland", full: "Nagaland,India", iso: "IN" },
  { code: 20465, name: "Odisha", full: "Odisha,India", iso: "IN" },
  { code: 20466, name: "Punjab", full: "Punjab,India", iso: "IN" },
  { code: 20468, name: "Rajasthan", full: "Rajasthan,India", iso: "IN" },
  { code: 21340, name: "Sikkim", full: "Sikkim,India", iso: "IN" },
  { code: 20469, name: "Tamil Nadu", full: "Tamil Nadu,India", iso: "IN" },
  { code: 9061642, name: "Telangana", full: "Telangana,India", iso: "IN" },
  { code: 20470, name: "Tripura", full: "Tripura,India", iso: "IN" },
  { code: 20471, name: "Uttar Pradesh", full: "Uttar Pradesh,India", iso: "IN" },
  { code: 21341, name: "Uttarakhand", full: "Uttarakhand,India", iso: "IN" },
  { code: 20472, name: "West Bengal", full: "West Bengal,India", iso: "IN" },
  { code: 2086, name: "British Indian Ocean Territory", full: "British Indian Ocean Territory", iso: "IO" },
  { code: 9069815, name: "Capital Region", full: "Capital Region,Iceland", iso: "IS" },
  { code: 9069813, name: "Eastern Region", full: "Eastern Region,Iceland", iso: "IS" },
  { code: 9070366, name: "Northeastern Region", full: "Northeastern Region,Iceland", iso: "IS" },
  { code: 9069816, name: "Northwestern Region", full: "Northwestern Region,Iceland", iso: "IS" },
  { code: 9069814, name: "Southern Peninsula Region", full: "Southern Peninsula Region,Iceland", iso: "IS" },
  { code: 9070365, name: "Southern Region", full: "Southern Region,Iceland", iso: "IS" },
  { code: 9069812, name: "Western Region", full: "Western Region,Iceland", iso: "IS" },
  { code: 9069811, name: "Westfjords Region", full: "Westfjords Region,Iceland", iso: "IS" },
  { code: 9053423, name: "Abruzzo", full: "Abruzzo,Italy", iso: "IT" },
  { code: 9053424, name: "Aosta", full: "Aosta,Italy", iso: "IT" },
  { code: 9053425, name: "Apulia", full: "Apulia,Italy", iso: "IT" },
  { code: 9053426, name: "Basilicata", full: "Basilicata,Italy", iso: "IT" },
  { code: 9053427, name: "Calabria", full: "Calabria,Italy", iso: "IT" },
  { code: 9053428, name: "Campania", full: "Campania,Italy", iso: "IT" },
  { code: 9053429, name: "Emilia-Romagna", full: "Emilia-Romagna,Italy", iso: "IT" },
  { code: 9053430, name: "Friuli-Venezia Giulia", full: "Friuli-Venezia Giulia,Italy", iso: "IT" },
  { code: 9053431, name: "Lazio", full: "Lazio,Italy", iso: "IT" },
  { code: 9053432, name: "Liguria", full: "Liguria,Italy", iso: "IT" },
  { code: 9053433, name: "Lombardy", full: "Lombardy,Italy", iso: "IT" },
  { code: 9053434, name: "Marche", full: "Marche,Italy", iso: "IT" },
  { code: 9053435, name: "Molise", full: "Molise,Italy", iso: "IT" },
  { code: 9053436, name: "Piedmont", full: "Piedmont,Italy", iso: "IT" },
  { code: 9053437, name: "Sardinia", full: "Sardinia,Italy", iso: "IT" },
  { code: 9053438, name: "Sicily", full: "Sicily,Italy", iso: "IT" },
  { code: 9053439, name: "Trentino-South Tyrol", full: "Trentino-South Tyrol,Italy", iso: "IT" },
  { code: 9053440, name: "Tuscany", full: "Tuscany,Italy", iso: "IT" },
  { code: 9053441, name: "Umbria", full: "Umbria,Italy", iso: "IT" },
  { code: 9053442, name: "Veneto", full: "Veneto,Italy", iso: "IT" },
  { code: 9075575, name: "Grouville", full: "Grouville,Jersey", iso: "JE" },
  { code: 9075576, name: "St Brelade", full: "St Brelade,Jersey", iso: "JE" },
  { code: 9075579, name: "St Clement", full: "St Clement,Jersey", iso: "JE" },
  { code: 9075578, name: "St John", full: "St John,Jersey", iso: "JE" },
  { code: 9075574, name: "St Lawrence", full: "St Lawrence,Jersey", iso: "JE" },
  { code: 9075581, name: "St Martin", full: "St Martin,Jersey", iso: "JE" },
  { code: 9075577, name: "St Mary", full: "St Mary,Jersey", iso: "JE" },
  { code: 9075573, name: "St. Ouen", full: "St. Ouen,Jersey", iso: "JE" },
  { code: 9075580, name: "St. Peter", full: "St. Peter,Jersey", iso: "JE" },
  { code: 9075582, name: "Trinity", full: "Trinity,Jersey", iso: "JE" },
  { code: 9070373, name: "Clarendon", full: "Clarendon,Jamaica", iso: "JM" },
  { code: 9069873, name: "Hanover Parish", full: "Hanover Parish,Jamaica", iso: "JM" },
  { code: 9069875, name: "Kingston Parish", full: "Kingston Parish,Jamaica", iso: "JM" },
  { code: 9070376, name: "Manchester Parish", full: "Manchester Parish,Jamaica", iso: "JM" },
  { code: 9069874, name: "Portland Parish", full: "Portland Parish,Jamaica", iso: "JM" },
  { code: 9070379, name: "St. Andrew Parish", full: "St. Andrew Parish,Jamaica", iso: "JM" },
  { code: 9070381, name: "St. Ann Parish", full: "St. Ann Parish,Jamaica", iso: "JM" },
  { code: 9070375, name: "St. Catherine Parish", full: "St. Catherine Parish,Jamaica", iso: "JM" },
  { code: 9075583, name: "St. Elizabeth Parish", full: "St. Elizabeth Parish,Jamaica", iso: "JM" },
  { code: 9070378, name: "St. James Parish", full: "St. James Parish,Jamaica", iso: "JM" },
  { code: 9070380, name: "St. Mary Parish", full: "St. Mary Parish,Jamaica", iso: "JM" },
  { code: 9070374, name: "St. Thomas Parish", full: "St. Thomas Parish,Jamaica", iso: "JM" },
  { code: 9070377, name: "Trelawny Parish", full: "Trelawny Parish,Jamaica", iso: "JM" },
  { code: 9069876, name: "Westmoreland Parish", full: "Westmoreland Parish,Jamaica", iso: "JM" },
  { code: 9070439, name: "Batken Region", full: "Batken Region,Kyrgyzstan", iso: "KG" },
  { code: 9070440, name: "Chuy Region", full: "Chuy Region,Kyrgyzstan", iso: "KG" },
  { code: 9070442, name: "Issyk-Kul Region", full: "Issyk-Kul Region,Kyrgyzstan", iso: "KG" },
  { code: 9070438, name: "Jalal-Abad Region", full: "Jalal-Abad Region,Kyrgyzstan", iso: "KG" },
  { code: 9070441, name: "Naryn Region", full: "Naryn Region,Kyrgyzstan", iso: "KG" },
  { code: 9070443, name: "Osh Region", full: "Osh Region,Kyrgyzstan", iso: "KG" },
  { code: 21319, name: "Busan", full: "Busan,South Korea", iso: "KR" },
  { code: 21327, name: "Chungcheongbuk-do", full: "Chungcheongbuk-do,South Korea", iso: "KR" },
  { code: 21328, name: "Chungcheongnam-do", full: "Chungcheongnam-do,South Korea", iso: "KR" },
  { code: 21320, name: "Daegu", full: "Daegu,South Korea", iso: "KR" },
  { code: 21323, name: "Daejeon", full: "Daejeon,South Korea", iso: "KR" },
  { code: 21326, name: "Gangwon-do", full: "Gangwon-do,South Korea", iso: "KR" },
  { code: 21322, name: "Gwangju", full: "Gwangju,South Korea", iso: "KR" },
  { code: 21325, name: "Gyeonggi-do", full: "Gyeonggi-do,South Korea", iso: "KR" },
  { code: 21331, name: "Gyeongsangbuk-do", full: "Gyeongsangbuk-do,South Korea", iso: "KR" },
  { code: 21332, name: "Gyeongsangnam-do", full: "Gyeongsangnam-do,South Korea", iso: "KR" },
  { code: 21321, name: "Incheon", full: "Incheon,South Korea", iso: "KR" },
  { code: 21333, name: "Jeju-do", full: "Jeju-do,South Korea", iso: "KR" },
  { code: 21329, name: "Jeollabuk-do", full: "Jeollabuk-do,South Korea", iso: "KR" },
  { code: 21330, name: "Jeollanam-do", full: "Jeollanam-do,South Korea", iso: "KR" },
  { code: 21318, name: "Seoul", full: "Seoul,South Korea", iso: "KR" },
  { code: 21324, name: "Ulsan", full: "Ulsan,South Korea", iso: "KR" },
  { code: 2136, name: "Cayman Islands", full: "Cayman Islands", iso: "KY" },
  { code: 9069573, name: "Kyzylorda Province", full: "Kyzylorda Province,Kazakhstan", iso: "KZ" },
  { code: 9069571, name: "Pavlodar Province", full: "Pavlodar Province,Kazakhstan", iso: "KZ" },
  { code: 9069572, name: "West Kazakhstan Province", full: "West Kazakhstan Province,Kazakhstan", iso: "KZ" },
  { code: 9073768, name: "Beni Mellal-Khenifra", full: "Beni Mellal-Khenifra,Morocco", iso: "MA" },
  { code: 9073769, name: "Casablanca-Settat", full: "Casablanca-Settat,Morocco", iso: "MA" },
  { code: 21524, name: "Chaouia-Ouardigha", full: "Chaouia-Ouardigha,Morocco", iso: "MA" },
  { code: 21525, name: "Doukkala-Abda", full: "Doukkala-Abda,Morocco", iso: "MA" },
  { code: 9073771, name: "Draa-Tafilalet", full: "Draa-Tafilalet,Morocco", iso: "MA" },
  { code: 21526, name: "Fes-Boulemane", full: "Fes-Boulemane,Fez-Meknes,Morocco", iso: "MA" },
  { code: 9073776, name: "Fez-Meknes", full: "Fez-Meknes,Morocco", iso: "MA" },
  { code: 21527, name: "Gharb-Chrarda-Beni Hssen", full: "Gharb-Chrarda-Beni Hssen,Morocco", iso: "MA" },
  { code: 21528, name: "Grand Casablanca", full: "Grand Casablanca,Casablanca-Settat,Morocco", iso: "MA" },
  { code: 21529, name: "Guelmim-Es Semara", full: "Guelmim-Es Semara,Morocco", iso: "MA" },
  { code: 9073777, name: "Guelmim-Oued Noun", full: "Guelmim-Oued Noun,Morocco", iso: "MA" },
  { code: 21530, name: "Laayoune-Boujdour-Sakia El Hamra", full: "Laayoune-Boujdour-Sakia El Hamra,Morocco", iso: "MA" },
  { code: 9073775, name: "Marrakesh-Safi", full: "Marrakesh-Safi,Morocco", iso: "MA" },
  { code: 21531, name: "Marrakesh-Tensift-El Haouz", full: "Marrakesh-Tensift-El Haouz,Marrakesh-Safi,Morocco", iso: "MA" },
  { code: 21532, name: "Meknes-Tafilalet", full: "Meknes-Tafilalet,Morocco", iso: "MA" },
  { code: 9073770, name: "Oriental", full: "Oriental,Morocco", iso: "MA" },
  { code: 21533, name: "Oriental", full: "Oriental,Oriental,Morocco", iso: "MA" },
  { code: 9073772, name: "Rabat-Sale-Kenitra", full: "Rabat-Sale-Kenitra,Morocco", iso: "MA" },
  { code: 21534, name: "Rabat-Sale-Zemmour-Zaer", full: "Rabat-Sale-Zemmour-Zaer,Morocco", iso: "MA" },
  { code: 9073774, name: "Souss-Massa", full: "Souss-Massa,Morocco", iso: "MA" },
  { code: 21535, name: "Souss-Massa-Draa", full: "Souss-Massa-Draa,Morocco", iso: "MA" },
  { code: 21536, name: "Tadla-Azilal", full: "Tadla-Azilal,Morocco", iso: "MA" },
  { code: 21537, name: "Tangier-Tetouan", full: "Tangier-Tetouan,Tangier-Tetouan-Al Hoceima,Morocco", iso: "MA" },
  { code: 9073773, name: "Tangier-Tetouan-Al Hoceima", full: "Tangier-Tetouan-Al Hoceima,Morocco", iso: "MA" },
  { code: 21538, name: "Taza-Al Hoceima-Taounate", full: "Taza-Al Hoceima-Taounate,Morocco", iso: "MA" },
  { code: 9069912, name: "Administrative-Territorial Units of the Left Bank of the Dniester", full: "Administrative-Territorial Units of the Left Bank of the Dniester,Moldova", iso: "MD" },
  { code: 9069924, name: "Gagauzia", full: "Gagauzia,Moldova", iso: "MD" },
  { code: 9070452, name: "Bamako Capital District", full: "Bamako Capital District,Mali", iso: "ML" },
  { code: 9070239, name: "Gao Region", full: "Gao Region,Mali", iso: "ML" },
  { code: 9070453, name: "Kayes Region", full: "Kayes Region,Mali", iso: "ML" },
  { code: 9070243, name: "Kidal Region", full: "Kidal Region,Mali", iso: "ML" },
  { code: 9070240, name: "Koulikoro Region", full: "Koulikoro Region,Mali", iso: "ML" },
  { code: 9070242, name: "Mopti Region", full: "Mopti Region,Mali", iso: "ML" },
  { code: 9070237, name: "Segou Region", full: "Segou Region,Mali", iso: "ML" },
  { code: 9070238, name: "Sikasso Region", full: "Sikasso Region,Mali", iso: "ML" },
  { code: 9070241, name: "Tombouctou Region", full: "Tombouctou Region,Mali", iso: "ML" },
  { code: 9065350, name: "Bago Region", full: "Bago Region,Myanmar (Burma)", iso: "MM" },
  { code: 9075777, name: "Chin State", full: "Chin State,Myanmar (Burma)", iso: "MM" },
  { code: 9065345, name: "Kachin", full: "Kachin,Myanmar (Burma)", iso: "MM" },
  { code: 9070181, name: "Kayah State", full: "Kayah State,Myanmar (Burma)", iso: "MM" },
  { code: 9065355, name: "Kayin State", full: "Kayin State,Myanmar (Burma)", iso: "MM" },
  { code: 9065347, name: "Magway Region", full: "Magway Region,Myanmar (Burma)", iso: "MM" },
  { code: 9065352, name: "Mandalay Region", full: "Mandalay Region,Myanmar (Burma)", iso: "MM" },
  { code: 9065354, name: "Mon State", full: "Mon State,Myanmar (Burma)", iso: "MM" },
  { code: 9065346, name: "Myawaddy", full: "Myawaddy,Kayin State,Myanmar (Burma)", iso: "MM" },
  { code: 9065349, name: "Naypyidaw Union Territory", full: "Naypyidaw Union Territory,Myanmar (Burma)", iso: "MM" },
  { code: 9065351, name: "Sagaing Region", full: "Sagaing Region,Myanmar (Burma)", iso: "MM" },
  { code: 9065356, name: "Shan", full: "Shan,Myanmar (Burma)", iso: "MM" },
  { code: 9065348, name: "Tanintharyi Region", full: "Tanintharyi Region,Myanmar (Burma)", iso: "MM" },
  { code: 9065353, name: "Yangon Region", full: "Yangon Region,Myanmar (Burma)", iso: "MM" },
  { code: 2446, name: "Macao", full: "Macao", iso: "MO" },
  { code: 2474, name: "Martinique", full: "Martinique", iso: "MQ" },
  { code: 9075805, name: "Adrar", full: "Adrar,Mauritania", iso: "MR" },
  { code: 9075809, name: "Dakhlet Nouadhibou", full: "Dakhlet Nouadhibou,Mauritania", iso: "MR" },
  { code: 9075806, name: "Gorgol", full: "Gorgol,Mauritania", iso: "MR" },
  { code: 9075808, name: "Guidimaka", full: "Guidimaka,Mauritania", iso: "MR" },
  { code: 9075804, name: "Hodh Ech Chargui", full: "Hodh Ech Chargui,Mauritania", iso: "MR" },
  { code: 9075810, name: "Inchiri", full: "Inchiri,Mauritania", iso: "MR" },
  { code: 9075807, name: "Trarza", full: "Trarza,Mauritania", iso: "MR" },
  { code: 2500, name: "Montserrat", full: "Montserrat", iso: "MS" },
  { code: 9075813, name: "Central Region", full: "Central Region,Malawi", iso: "MW" },
  { code: 9075812, name: "Northern Region", full: "Northern Region,Malawi", iso: "MW" },
  { code: 9075814, name: "Southern Region", full: "Southern Region,Malawi", iso: "MW" },
  { code: 20694, name: "Aguascalientes", full: "Aguascalientes,Mexico", iso: "MX" },
  { code: 20697, name: "Baja California Sur", full: "Baja California Sur,Mexico", iso: "MX" },
  { code: 20696, name: "Baja California", full: "Baja California,Mexico", iso: "MX" },
  { code: 20698, name: "Campeche", full: "Campeche,Mexico", iso: "MX" },
  { code: 20700, name: "Chiapas", full: "Chiapas,Mexico", iso: "MX" },
  { code: 20699, name: "Chihuahua", full: "Chihuahua,Mexico", iso: "MX" },
  { code: 20701, name: "Coahuila", full: "Coahuila,Mexico", iso: "MX" },
  { code: 20702, name: "Colima", full: "Colima,Mexico", iso: "MX" },
  { code: 20704, name: "Durango", full: "Durango,Mexico", iso: "MX" },
  { code: 20706, name: "Guanajuato", full: "Guanajuato,Mexico", iso: "MX" },
  { code: 20705, name: "Guerrero", full: "Guerrero,Mexico", iso: "MX" },
  { code: 20707, name: "Hidalgo", full: "Hidalgo,Mexico", iso: "MX" },
  { code: 20708, name: "Jalisco", full: "Jalisco,Mexico", iso: "MX" },
  { code: 20703, name: "Mexico City", full: "Mexico City,Mexico", iso: "MX" },
  { code: 20710, name: "Michoacan", full: "Michoacan,Mexico", iso: "MX" },
  { code: 20711, name: "Morelos", full: "Morelos,Mexico", iso: "MX" },
  { code: 20712, name: "Nayarit", full: "Nayarit,Mexico", iso: "MX" },
  { code: 20713, name: "Nuevo Leon", full: "Nuevo Leon,Mexico", iso: "MX" },
  { code: 20714, name: "Oaxaca", full: "Oaxaca,Mexico", iso: "MX" },
  { code: 20715, name: "Puebla", full: "Puebla,Mexico", iso: "MX" },
  { code: 20716, name: "Queretaro", full: "Queretaro,Mexico", iso: "MX" },
  { code: 20717, name: "Quintana Roo", full: "Quintana Roo,Mexico", iso: "MX" },
  { code: 20719, name: "San Luis Potosi", full: "San Luis Potosi,Mexico", iso: "MX" },
  { code: 20718, name: "Sinaloa", full: "Sinaloa,Mexico", iso: "MX" },
  { code: 20720, name: "Sonora", full: "Sonora,Mexico", iso: "MX" },
  { code: 20709, name: "State of Mexico", full: "State of Mexico,Mexico", iso: "MX" },
  { code: 20721, name: "Tabasco", full: "Tabasco,Mexico", iso: "MX" },
  { code: 20722, name: "Tamaulipas", full: "Tamaulipas,Mexico", iso: "MX" },
  { code: 20723, name: "Tlaxcala", full: "Tlaxcala,Mexico", iso: "MX" },
  { code: 20724, name: "Veracruz", full: "Veracruz,Mexico", iso: "MX" },
  { code: 20725, name: "Yucatan", full: "Yucatan,Mexico", iso: "MX" },
  { code: 20726, name: "Zacatecas", full: "Zacatecas,Mexico", iso: "MX" },
  { code: 20751, name: "Federal Territory of Kuala Lumpur", full: "Federal Territory of Kuala Lumpur,Malaysia", iso: "MY" },
  { code: 20741, name: "Johor", full: "Johor,Malaysia", iso: "MY" },
  { code: 20742, name: "Kedah", full: "Kedah,Malaysia", iso: "MY" },
  { code: 20740, name: "Kelantan", full: "Kelantan,Malaysia", iso: "MY" },
  { code: 20743, name: "Labuan Federal Territory", full: "Labuan Federal Territory,Malaysia", iso: "MY" },
  { code: 20744, name: "Malacca", full: "Malacca,Malaysia", iso: "MY" },
  { code: 20745, name: "Negeri Sembilan", full: "Negeri Sembilan,Malaysia", iso: "MY" },
  { code: 20739, name: "Pahang", full: "Pahang,Malaysia", iso: "MY" },
  { code: 20746, name: "Penang", full: "Penang,Malaysia", iso: "MY" },
  { code: 20737, name: "Perak", full: "Perak,Malaysia", iso: "MY" },
  { code: 20747, name: "Perlis", full: "Perlis,Malaysia", iso: "MY" },
  { code: 21539, name: "Putrajaya", full: "Putrajaya,Malaysia", iso: "MY" },
  { code: 20748, name: "Sabah", full: "Sabah,Malaysia", iso: "MY" },
  { code: 20749, name: "Sarawak", full: "Sarawak,Malaysia", iso: "MY" },
  { code: 20738, name: "Selangor", full: "Selangor,Malaysia", iso: "MY" },
  { code: 20750, name: "Terengganu", full: "Terengganu,Malaysia", iso: "MY" },
  { code: 9070429, name: "Erongo Region", full: "Erongo Region,Namibia", iso: "NA" },
  { code: 9070087, name: "Hardap Region", full: "Hardap Region,Namibia", iso: "NA" },
  { code: 9070089, name: "Karas Region", full: "Karas Region,Namibia", iso: "NA" },
  { code: 9070086, name: "Kavango Region", full: "Kavango Region,Namibia", iso: "NA" },
  { code: 9070080, name: "Khomas Region", full: "Khomas Region,Namibia", iso: "NA" },
  { code: 9070088, name: "Kunene Region", full: "Kunene Region,Namibia", iso: "NA" },
  { code: 9070428, name: "Ohangwena Region", full: "Ohangwena Region,Namibia", iso: "NA" },
  { code: 9070427, name: "Omaheke Region", full: "Omaheke Region,Namibia", iso: "NA" },
  { code: 9070085, name: "Omusati Region", full: "Omusati Region,Namibia", iso: "NA" },
  { code: 9070083, name: "Oshana Region", full: "Oshana Region,Namibia", iso: "NA" },
  { code: 9070081, name: "Oshikoto Region", full: "Oshikoto Region,Namibia", iso: "NA" },
  { code: 9070082, name: "Otjozondjupa Region", full: "Otjozondjupa Region,Namibia", iso: "NA" },
  { code: 9070084, name: "Zambezi Region", full: "Zambezi Region,Namibia", iso: "NA" },
  { code: 9070278, name: "Agadez Region", full: "Agadez Region,Niger", iso: "NE" },
  { code: 9070274, name: "Diffa Region", full: "Diffa Region,Niger", iso: "NE" },
  { code: 9070273, name: "Dosso Region", full: "Dosso Region,Niger", iso: "NE" },
  { code: 9070275, name: "Maradi Region", full: "Maradi Region,Niger", iso: "NE" },
  { code: 9070454, name: "Niamey Urban Community", full: "Niamey Urban Community,Niger", iso: "NE" },
  { code: 9070277, name: "Tahoua Region", full: "Tahoua Region,Niger", iso: "NE" },
  { code: 9070276, name: "Tillaberi Region", full: "Tillaberi Region,Niger", iso: "NE" },
  { code: 9070279, name: "Zinder Region", full: "Zinder Region,Niger", iso: "NE" },
  { code: 21540, name: "Abia", full: "Abia,Nigeria", iso: "NG" },
  { code: 21542, name: "Adamawa", full: "Adamawa,Nigeria", iso: "NG" },
  { code: 21543, name: "Akwa Ibom", full: "Akwa Ibom,Nigeria", iso: "NG" },
  { code: 21544, name: "Anambra", full: "Anambra,Nigeria", iso: "NG" },
  { code: 21545, name: "Bauchi", full: "Bauchi,Nigeria", iso: "NG" },
  { code: 21546, name: "Bayelsa", full: "Bayelsa,Nigeria", iso: "NG" },
  { code: 21547, name: "Benue", full: "Benue,Nigeria", iso: "NG" },
  { code: 21548, name: "Borno", full: "Borno,Nigeria", iso: "NG" },
  { code: 21549, name: "Cross River", full: "Cross River,Nigeria", iso: "NG" },
  { code: 21550, name: "Delta", full: "Delta,Nigeria", iso: "NG" },
  { code: 21551, name: "Ebonyi", full: "Ebonyi,Nigeria", iso: "NG" },
  { code: 21552, name: "Edo", full: "Edo,Nigeria", iso: "NG" },
  { code: 21553, name: "Ekiti", full: "Ekiti,Nigeria", iso: "NG" },
  { code: 21554, name: "Enugu", full: "Enugu,Nigeria", iso: "NG" },
  { code: 21541, name: "Federal Capital Territory", full: "Federal Capital Territory,Nigeria", iso: "NG" },
  { code: 21555, name: "Gombe", full: "Gombe,Nigeria", iso: "NG" },
  { code: 21556, name: "Imo", full: "Imo,Nigeria", iso: "NG" },
  { code: 21557, name: "Jigawa", full: "Jigawa,Nigeria", iso: "NG" },
  { code: 21558, name: "Kaduna", full: "Kaduna,Nigeria", iso: "NG" },
  { code: 21559, name: "Kano", full: "Kano,Nigeria", iso: "NG" },
  { code: 21560, name: "Katsina", full: "Katsina,Nigeria", iso: "NG" },
  { code: 21561, name: "Kebbi", full: "Kebbi,Nigeria", iso: "NG" },
  { code: 21562, name: "Kogi", full: "Kogi,Nigeria", iso: "NG" },
  { code: 21563, name: "Kwara", full: "Kwara,Nigeria", iso: "NG" },
  { code: 21564, name: "Lagos", full: "Lagos,Nigeria", iso: "NG" },
  { code: 21565, name: "Nasarawa", full: "Nasarawa,Nigeria", iso: "NG" },
  { code: 21566, name: "Niger", full: "Niger,Nigeria", iso: "NG" },
  { code: 21567, name: "Ogun State", full: "Ogun State,Nigeria", iso: "NG" },
  { code: 21568, name: "Ondo", full: "Ondo,Nigeria", iso: "NG" },
  { code: 21569, name: "Osun", full: "Osun,Nigeria", iso: "NG" },
  { code: 21570, name: "Oyo", full: "Oyo,Nigeria", iso: "NG" },
  { code: 21571, name: "Plateau", full: "Plateau,Nigeria", iso: "NG" },
  { code: 21572, name: "Rivers", full: "Rivers,Nigeria", iso: "NG" },
  { code: 21573, name: "Sokoto", full: "Sokoto,Nigeria", iso: "NG" },
  { code: 21574, name: "Taraba", full: "Taraba,Nigeria", iso: "NG" },
  { code: 21575, name: "Yobe", full: "Yobe,Nigeria", iso: "NG" },
  { code: 21576, name: "Zamfara", full: "Zamfara,Nigeria", iso: "NG" },
  { code: 9070010, name: "North Caribbean Coast Autonomous Region", full: "North Caribbean Coast Autonomous Region,Nicaragua", iso: "NI" },
  { code: 9070005, name: "South Caribbean Coast Autonomous Region", full: "South Caribbean Coast Autonomous Region,Nicaragua", iso: "NI" },
  { code: 9070016, name: "Central Development Region", full: "Central Development Region,Nepal", iso: "NP" },
  { code: 9075818, name: "Eastern Development Region", full: "Eastern Development Region,Nepal", iso: "NP" },
  { code: 9070018, name: "Far-Western Development Region", full: "Far-Western Development Region,Nepal", iso: "NP" },
  { code: 9070017, name: "Mid-Western Development Region", full: "Mid-Western Development Region,Nepal", iso: "NP" },
  { code: 9070019, name: "Western Development Region", full: "Western Development Region,Nepal", iso: "NP" },
  { code: 20791, name: "Auckland", full: "Auckland,New Zealand", iso: "NZ" },
  { code: 20792, name: "Bay of Plenty", full: "Bay of Plenty,New Zealand", iso: "NZ" },
  { code: 21302, name: "Canterbury", full: "Canterbury,New Zealand", iso: "NZ" },
  { code: 9047106, name: "Chatham Islands Territory", full: "Chatham Islands Territory,New Zealand", iso: "NZ" },
  { code: 21303, name: "Gisborne", full: "Gisborne,New Zealand", iso: "NZ" },
  { code: 21304, name: "Hawke's Bay", full: "Hawke's Bay,New Zealand", iso: "NZ" },
  { code: 21305, name: "Manawatu-Wanganui", full: "Manawatu-Wanganui,New Zealand", iso: "NZ" },
  { code: 21306, name: "Marlborough", full: "Marlborough,New Zealand", iso: "NZ" },
  { code: 21307, name: "Nelson", full: "Nelson,New Zealand", iso: "NZ" },
  { code: 21308, name: "Northland", full: "Northland,New Zealand", iso: "NZ" },
  { code: 21309, name: "Otago", full: "Otago,New Zealand", iso: "NZ" },
  { code: 21310, name: "Southland", full: "Southland,New Zealand", iso: "NZ" },
  { code: 21311, name: "Taranaki", full: "Taranaki,New Zealand", iso: "NZ" },
  { code: 21312, name: "Tasman", full: "Tasman,New Zealand", iso: "NZ" },
  { code: 21313, name: "Waikato", full: "Waikato,New Zealand", iso: "NZ" },
  { code: 21314, name: "Wellington", full: "Wellington,New Zealand", iso: "NZ" },
  { code: 21315, name: "West Coast", full: "West Coast,New Zealand", iso: "NZ" },
  { code: 9069748, name: "Embera-Wounaan Comarca", full: "Embera-Wounaan Comarca,Panama", iso: "PA" },
  { code: 9069746, name: "Ngabe-Bugle Comarca", full: "Ngabe-Bugle Comarca,Panama", iso: "PA" },
  { code: 9061338, name: "Amazonas", full: "Amazonas,Peru", iso: "PE" },
  { code: 20796, name: "Ancash", full: "Ancash,Peru", iso: "PE" },
  { code: 9061336, name: "Apurimac", full: "Apurimac,Peru", iso: "PE" },
  { code: 20797, name: "Arequipa", full: "Arequipa,Peru", iso: "PE" },
  { code: 20798, name: "Ayacucho", full: "Ayacucho,Peru", iso: "PE" },
  { code: 20799, name: "Cajamarca", full: "Cajamarca,Peru", iso: "PE" },
  { code: 20800, name: "Callao Region", full: "Callao Region,Peru", iso: "PE" },
  { code: 20801, name: "Cusco", full: "Cusco,Peru", iso: "PE" },
  { code: 20803, name: "Huancavelica", full: "Huancavelica,Peru", iso: "PE" },
  { code: 20802, name: "Huanuco", full: "Huanuco,Peru", iso: "PE" },
  { code: 20804, name: "Ica", full: "Ica,Peru", iso: "PE" },
  { code: 20805, name: "Junin", full: "Junin,Peru", iso: "PE" },
  { code: 20806, name: "La Libertad", full: "La Libertad,Peru", iso: "PE" },
  { code: 20807, name: "Lambayeque", full: "Lambayeque,Peru", iso: "PE" },
  { code: 20808, name: "Lima Region", full: "Lima Region,Peru", iso: "PE" },
  { code: 20809, name: "Loreto", full: "Loreto,Peru", iso: "PE" },
  { code: 9061337, name: "Madre de Dios", full: "Madre de Dios,Peru", iso: "PE" },
  { code: 20810, name: "Moquegua", full: "Moquegua,Peru", iso: "PE" },
  { code: 20811, name: "Pasco", full: "Pasco,Peru", iso: "PE" },
  { code: 20812, name: "Piura", full: "Piura,Peru", iso: "PE" },
  { code: 20813, name: "Puno", full: "Puno,Peru", iso: "PE" },
  { code: 20814, name: "San Martin", full: "San Martin,Peru", iso: "PE" },
  { code: 20815, name: "Tacna", full: "Tacna,Peru", iso: "PE" },
  { code: 9061339, name: "Tumbes", full: "Tumbes,Peru", iso: "PE" },
  { code: 20816, name: "Ucayali", full: "Ucayali,Peru", iso: "PE" },
  { code: 9061355, name: "Autonomous Region in Muslim Mindanao", full: "Autonomous Region in Muslim Mindanao,Philippines", iso: "PH" },
  { code: 9061349, name: "Bicol", full: "Bicol,Philippines", iso: "PH" },
  { code: 9061348, name: "Cagayan Valley", full: "Cagayan Valley,Philippines", iso: "PH" },
  { code: 9061340, name: "Calabarzon", full: "Calabarzon,Philippines", iso: "PH" },
  { code: 9061352, name: "Caraga", full: "Caraga,Philippines", iso: "PH" },
  { code: 9061341, name: "Central Luzon", full: "Central Luzon,Philippines", iso: "PH" },
  { code: 9061344, name: "Central Visayas", full: "Central Visayas,Philippines", iso: "PH" },
  { code: 9061353, name: "Cordillera Administrative Region", full: "Cordillera Administrative Region,Philippines", iso: "PH" },
  { code: 9061343, name: "Davao Region", full: "Davao Region,Philippines", iso: "PH" },
  { code: 9061351, name: "Eastern Visayas", full: "Eastern Visayas,Philippines", iso: "PH" },
  { code: 9061345, name: "Ilocos Region", full: "Ilocos Region,Philippines", iso: "PH" },
  { code: 9067377, name: "Indangan", full: "Indangan,Davao Region,Philippines", iso: "PH" },
  { code: 9067376, name: "Kalunasan", full: "Kalunasan,Central Visayas,Philippines", iso: "PH" },
  { code: 9061350, name: "MIMAROPA", full: "MIMAROPA,Philippines", iso: "PH" },
  { code: 20835, name: "Metro Manila", full: "Metro Manila,Philippines", iso: "PH" },
  { code: 9061346, name: "Northern Mindanao", full: "Northern Mindanao,Philippines", iso: "PH" },
  { code: 9061347, name: "Region XII", full: "Region XII,Philippines", iso: "PH" },
  { code: 9061342, name: "Western Visayas", full: "Western Visayas,Philippines", iso: "PH" },
  { code: 9061354, name: "Zamboanga Peninsula", full: "Zamboanga Peninsula,Philippines", iso: "PH" },
  { code: 9061361, name: "Azad Jammu and Kashmir", full: "Azad Jammu and Kashmir,Pakistan", iso: "PK" },
  { code: 9061359, name: "Balochistan", full: "Balochistan,Pakistan", iso: "PK" },
  { code: 9061362, name: "Federally Administered Tribal Area", full: "Federally Administered Tribal Area,Khyber Pakhtunkhwa,Pakistan", iso: "PK" },
  { code: 9061363, name: "Gilgit-Baltistan", full: "Gilgit-Baltistan,Pakistan", iso: "PK" },
  { code: 9061360, name: "Islamabad Capital Territory", full: "Islamabad Capital Territory,Pakistan", iso: "PK" },
  { code: 9061358, name: "Khyber Pakhtunkhwa", full: "Khyber Pakhtunkhwa,Pakistan", iso: "PK" },
  { code: 9061357, name: "Punjab", full: "Punjab,Pakistan", iso: "PK" },
  { code: 9061356, name: "Sindh", full: "Sindh,Pakistan", iso: "PK" },
  { code: 20861, name: "Greater Poland Voivodeship", full: "Greater Poland Voivodeship,Poland", iso: "PL" },
  { code: 20848, name: "Kuyavian-Pomeranian Voivodeship", full: "Kuyavian-Pomeranian Voivodeship,Poland", iso: "PL" },
  { code: 20852, name: "Lesser Poland Voivodeship", full: "Lesser Poland Voivodeship,Poland", iso: "PL" },
  { code: 20850, name: "Lodz Voivodeship", full: "Lodz Voivodeship,Poland", iso: "PL" },
  { code: 20847, name: "Lower Silesian Voivodeship", full: "Lower Silesian Voivodeship,Poland", iso: "PL" },
  { code: 20851, name: "Lublin Voivodeship", full: "Lublin Voivodeship,Poland", iso: "PL" },
  { code: 20849, name: "Lubusz Voivodeship", full: "Lubusz Voivodeship,Poland", iso: "PL" },
  { code: 20853, name: "Masovian Voivodeship", full: "Masovian Voivodeship,Poland", iso: "PL" },
  { code: 20854, name: "Opole Voivodeship", full: "Opole Voivodeship,Poland", iso: "PL" },
  { code: 20856, name: "Podkarpackie Voivodeship", full: "Podkarpackie Voivodeship,Poland", iso: "PL" },
  { code: 20855, name: "Podlaskie Voivodeship", full: "Podlaskie Voivodeship,Poland", iso: "PL" },
  { code: 20857, name: "Pomeranian Voivodeship", full: "Pomeranian Voivodeship,Poland", iso: "PL" },
  { code: 20859, name: "Silesian Voivodeship", full: "Silesian Voivodeship,Poland", iso: "PL" },
  { code: 20858, name: "Swietokrzyskie Voivodeship", full: "Swietokrzyskie Voivodeship,Poland", iso: "PL" },
  { code: 20860, name: "Warmian-Masurian Voivodeship", full: "Warmian-Masurian Voivodeship,Poland", iso: "PL" },
  { code: 20862, name: "West Pomeranian Voivodeship", full: "West Pomeranian Voivodeship,Poland", iso: "PL" },
  { code: 2630, name: "Puerto Rico", full: "Puerto Rico", iso: "PR" },
  { code: 2275, name: "Palestine", full: "Palestine", iso: "PS" },
  { code: 20865, name: "Aveiro District", full: "Aveiro District,Portugal", iso: "PT" },
  { code: 20881, name: "Azores", full: "Azores,Portugal", iso: "PT" },
  { code: 21255, name: "Beja District", full: "Beja District,Portugal", iso: "PT" },
  { code: 20866, name: "Braga", full: "Braga,Portugal", iso: "PT" },
  { code: 20867, name: "Braganca District", full: "Braganca District,Portugal", iso: "PT" },
  { code: 20868, name: "Castelo Branco District", full: "Castelo Branco District,Portugal", iso: "PT" },
  { code: 20869, name: "Coimbra District", full: "Coimbra District,Portugal", iso: "PT" },
  { code: 20870, name: "Evora District", full: "Evora District,Portugal", iso: "PT" },
  { code: 20871, name: "Faro District", full: "Faro District,Portugal", iso: "PT" },
  { code: 20872, name: "Guarda District", full: "Guarda District,Portugal", iso: "PT" },
  { code: 20873, name: "Leiria District", full: "Leiria District,Portugal", iso: "PT" },
  { code: 20874, name: "Lisbon", full: "Lisbon,Portugal", iso: "PT" },
  { code: 20882, name: "Madeira", full: "Madeira,Portugal", iso: "PT" },
  { code: 20875, name: "Portalegre District", full: "Portalegre District,Portugal", iso: "PT" },
  { code: 20876, name: "Porto District", full: "Porto District,Portugal", iso: "PT" },
  { code: 20877, name: "Santarem District", full: "Santarem District,Portugal", iso: "PT" },
  { code: 20878, name: "Setubal", full: "Setubal,Portugal", iso: "PT" },
  { code: 20879, name: "Viana do Castelo District", full: "Viana do Castelo District,Portugal", iso: "PT" },
  { code: 9047107, name: "Vila Real District", full: "Vila Real District,Portugal", iso: "PT" },
  { code: 20880, name: "Viseu District", full: "Viseu District,Portugal", iso: "PT" },
  { code: 2638, name: "Reunion", full: "Reunion", iso: "RE" },
  { code: 9075869, name: "Brezice", full: "Brezice,Slovenia", iso: "SI" },
  { code: 9075863, name: "Celje", full: "Celje,Slovenia", iso: "SI" },
  { code: 9075887, name: "Cerknica", full: "Cerknica,Slovenia", iso: "SI" },
  { code: 9075851, name: "Crnomelj", full: "Crnomelj,Slovenia", iso: "SI" },
  { code: 9075849, name: "Domzale", full: "Domzale,Slovenia", iso: "SI" },
  { code: 9075864, name: "Dravograd", full: "Dravograd,Slovenia", iso: "SI" },
  { code: 9075845, name: "Gornja Radgona", full: "Gornja Radgona,Slovenia", iso: "SI" },
  { code: 9075856, name: "Grosuplje", full: "Grosuplje,Slovenia", iso: "SI" },
  { code: 9075894, name: "Idrija", full: "Idrija,Slovenia", iso: "SI" },
  { code: 9075854, name: "Ilirska Bistrica", full: "Ilirska Bistrica,Slovenia", iso: "SI" },
  { code: 9075876, name: "Izola", full: "Izola,Slovenia", iso: "SI" },
  { code: 9075852, name: "Jesenice", full: "Jesenice,Slovenia", iso: "SI" },
  { code: 9075859, name: "Kamnik", full: "Kamnik,Slovenia", iso: "SI" },
  { code: 9075893, name: "Koper", full: "Koper,Slovenia", iso: "SI" },
  { code: 9075871, name: "Kranj", full: "Kranj,Slovenia", iso: "SI" },
  { code: 9075877, name: "Krsko", full: "Krsko,Slovenia", iso: "SI" },
  { code: 9075885, name: "Lasko", full: "Lasko,Slovenia", iso: "SI" },
  { code: 9075867, name: "Lenart", full: "Lenart,Slovenia", iso: "SI" },
  { code: 9075844, name: "Lendava", full: "Lendava,Slovenia", iso: "SI" },
  { code: 9075873, name: "Litija", full: "Litija,Slovenia", iso: "SI" },
  { code: 9075874, name: "Ljubljana", full: "Ljubljana,Slovenia", iso: "SI" },
  { code: 9075878, name: "Ljutomer", full: "Ljutomer,Slovenia", iso: "SI" },
  { code: 9075865, name: "Logatec", full: "Logatec,Slovenia", iso: "SI" },
  { code: 9075850, name: "Metlika", full: "Metlika,Slovenia", iso: "SI" },
  { code: 9075892, name: "Mozirje", full: "Mozirje,Slovenia", iso: "SI" },
  { code: 9075862, name: "Murska Sobota", full: "Murska Sobota,Slovenia", iso: "SI" },
  { code: 9075890, name: "Nova Gorica", full: "Nova Gorica,Slovenia", iso: "SI" },
  { code: 9075891, name: "Novo Mesto", full: "Novo Mesto,Slovenia", iso: "SI" },
  { code: 9075881, name: "Ormoz", full: "Ormoz,Slovenia", iso: "SI" },
  { code: 9075882, name: "Pesnica", full: "Pesnica,Slovenia", iso: "SI" },
  { code: 9075858, name: "Piran", full: "Piran,Slovenia", iso: "SI" },
  { code: 9075855, name: "Postojna", full: "Postojna,Slovenia", iso: "SI" },
  { code: 9075870, name: "Ptuj", full: "Ptuj,Slovenia", iso: "SI" },
  { code: 9075879, name: "Radlje ob Dravi", full: "Radlje ob Dravi,Slovenia", iso: "SI" },
  { code: 9075884, name: "Radovljica", full: "Radovljica,Slovenia", iso: "SI" },
  { code: 9075860, name: "Ravne na Koroskem", full: "Ravne na Koroskem,Slovenia", iso: "SI" },
  { code: 9075880, name: "Ruse", full: "Ruse,Slovenia", iso: "SI" },
  { code: 9075846, name: "Sentjur", full: "Sentjur,Slovenia", iso: "SI" },
  { code: 9075868, name: "Sevnica", full: "Sevnica,Slovenia", iso: "SI" },
  { code: 9075857, name: "Sezana", full: "Sezana,Slovenia", iso: "SI" },
  { code: 9075886, name: "Slovenj Gradec", full: "Slovenj Gradec,Slovenia", iso: "SI" },
  { code: 9075875, name: "Slovenska Bistrica", full: "Slovenska Bistrica,Slovenia", iso: "SI" },
  { code: 9075847, name: "Slovenske Konjice", full: "Slovenske Konjice,Slovenia", iso: "SI" },
  { code: 9075853, name: "Smarje pri Jelsah", full: "Smarje pri Jelsah,Slovenia", iso: "SI" },
  { code: 9075883, name: "Tolmin", full: "Tolmin,Slovenia", iso: "SI" },
  { code: 9075866, name: "Trebnje", full: "Trebnje,Slovenia", iso: "SI" },
  { code: 9075872, name: "Trzic", full: "Trzic,Slovenia", iso: "SI" },
  { code: 9075889, name: "Velenje", full: "Velenje,Slovenia", iso: "SI" },
  { code: 9075861, name: "Vrhnika", full: "Vrhnika,Slovenia", iso: "SI" },
  { code: 9075888, name: "Zagorje ob Savi", full: "Zagorje ob Savi,Slovenia", iso: "SI" },
  { code: 9075848, name: "Zalec", full: "Zalec,Slovenia", iso: "SI" },
  { code: 2744, name: "Svalbard and Jan Mayen", full: "Svalbard and Jan Mayen", iso: "SJ" },
  { code: 9062581, name: "Banska Bystrica Region", full: "Banska Bystrica Region,Slovakia", iso: "SK" },
  { code: 9062586, name: "Bratislava Region", full: "Bratislava Region,Slovakia", iso: "SK" },
  { code: 9062584, name: "Kosice Region", full: "Kosice Region,Slovakia", iso: "SK" },
  { code: 9062585, name: "Nitra Region", full: "Nitra Region,Slovakia", iso: "SK" },
  { code: 9062583, name: "Presov Region", full: "Presov Region,Slovakia", iso: "SK" },
  { code: 9062580, name: "Trencin Region", full: "Trencin Region,Slovakia", iso: "SK" },
  { code: 9062587, name: "Trnava Region", full: "Trnava Region,Slovakia", iso: "SK" },
  { code: 9062582, name: "Zilina Region", full: "Zilina Region,Slovakia", iso: "SK" },
  { code: 9075895, name: "Western Area", full: "Western Area,Sierra Leone", iso: "SL" },
  { code: 9070424, name: "Dakar Region", full: "Dakar Region,Senegal", iso: "SN" },
  { code: 9070425, name: "Diourbel Region", full: "Diourbel Region,Senegal", iso: "SN" },
  { code: 9070068, name: "Fatick Region", full: "Fatick Region,Senegal", iso: "SN" },
  { code: 9070069, name: "Kaffrine Region", full: "Kaffrine Region,Senegal", iso: "SN" },
  { code: 9070061, name: "Kaolack Region", full: "Kaolack Region,Senegal", iso: "SN" },
  { code: 9070062, name: "Kedougou Region", full: "Kedougou Region,Senegal", iso: "SN" },
  { code: 9070064, name: "Kolda Region", full: "Kolda Region,Senegal", iso: "SN" },
  { code: 9070063, name: "Louga Region", full: "Louga Region,Senegal", iso: "SN" },
  { code: 9070067, name: "Matam Region", full: "Matam Region,Senegal", iso: "SN" },
  { code: 9070071, name: "Saint-Louis Region", full: "Saint-Louis Region,Senegal", iso: "SN" },
  { code: 9070070, name: "Sedhiou Region", full: "Sedhiou Region,Senegal", iso: "SN" },
  { code: 9070066, name: "Tambacounda Region", full: "Tambacounda Region,Senegal", iso: "SN" },
  { code: 9070065, name: "Thies Region", full: "Thies Region,Senegal", iso: "SN" },
  { code: 9070060, name: "Ziguinchor Region", full: "Ziguinchor Region,Senegal", iso: "SN" },
  { code: 9075916, name: "Awdal", full: "Awdal,Somalia", iso: "SO" },
  { code: 9075908, name: "Banaadir", full: "Banaadir,Somalia", iso: "SO" },
  { code: 9075918, name: "Bari", full: "Bari,Somalia", iso: "SO" },
  { code: 9075919, name: "Bay", full: "Bay,Somalia", iso: "SO" },
  { code: 9075917, name: "Gedo", full: "Gedo,Somalia", iso: "SO" },
  { code: 9075913, name: "Lower Juba", full: "Lower Juba,Somalia", iso: "SO" },
  { code: 9075912, name: "Mudug", full: "Mudug,Somalia", iso: "SO" },
  { code: 9075914, name: "Nugal", full: "Nugal,Somalia", iso: "SO" },
  { code: 9075909, name: "Sanaag", full: "Sanaag,Somalia", iso: "SO" },
  { code: 9075907, name: "Shabeellaha Hoose", full: "Shabeellaha Hoose,Somalia", iso: "SO" },
  { code: 9075911, name: "Sool", full: "Sool,Somalia", iso: "SO" },
  { code: 9075915, name: "Togdheer", full: "Togdheer,Somalia", iso: "SO" },
  { code: 9075910, name: "Woqooyi Galbeed", full: "Woqooyi Galbeed,Somalia", iso: "SO" },
  { code: 9070267, name: "Hhohho Region", full: "Hhohho Region,Eswatini", iso: "SZ" },
  { code: 9070266, name: "Lubombo Region", full: "Lubombo Region,Eswatini", iso: "SZ" },
  { code: 9070268, name: "Manzini", full: "Manzini,Eswatini", iso: "SZ" },
  { code: 9070265, name: "Shiselweni Region", full: "Shiselweni Region,Eswatini", iso: "SZ" },
  { code: 2796, name: "Turks and Caicos Islands", full: "Turks and Caicos Islands", iso: "TC" },
  { code: 9075927, name: "Borkou", full: "Borkou,Chad", iso: "TD" },
  { code: 9075925, name: "Chari-Baguirmi", full: "Chari-Baguirmi,Chad", iso: "TD" },
  { code: 9075926, name: "Hadjer-Lamis", full: "Hadjer-Lamis,Chad", iso: "TD" },
  { code: 9070261, name: "Centrale Region", full: "Centrale Region,Togo", iso: "TG" },
  { code: 9070262, name: "Kara Region", full: "Kara Region,Togo", iso: "TG" },
  { code: 9070263, name: "Maritime Region", full: "Maritime Region,Togo", iso: "TG" },
  { code: 9070264, name: "Plateaux Region", full: "Plateaux Region,Togo", iso: "TG" },
  { code: 9070260, name: "Savanes Region", full: "Savanes Region,Togo", iso: "TG" },
  { code: 9075930, name: "Ahal", full: "Ahal,Turkmenistan", iso: "TM" },
  { code: 9075932, name: "Ashgabat", full: "Ashgabat,Turkmenistan", iso: "TM" },
  { code: 9075931, name: "Balkan", full: "Balkan,Turkmenistan", iso: "TM" },
  { code: 9075934, name: "Lebap", full: "Lebap,Turkmenistan", iso: "TM" },
  { code: 9075933, name: "Mary", full: "Mary,Turkmenistan", iso: "TM" },
  { code: 9075954, name: "Couva-Tabaquite-Talparo Regional Corporation", full: "Couva-Tabaquite-Talparo Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075956, name: "Diego Martin Regional Corporation", full: "Diego Martin Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075955, name: "Eastern Tobago", full: "Eastern Tobago,Trinidad and Tobago", iso: "TT" },
  { code: 9075953, name: "Mayaro Rio Claro Regional Corporation", full: "Mayaro Rio Claro Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075951, name: "Penal/Debe Regional Corporation", full: "Penal/Debe Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075960, name: "Princes Town Regional Corporation", full: "Princes Town Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075952, name: "San Juan-Laventille Regional Corporation", full: "San Juan-Laventille Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075958, name: "Sangre Grande Regional Corporation", full: "Sangre Grande Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075961, name: "Siparia Regional Corporation", full: "Siparia Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075957, name: "Tunapuna/Piarco Regional Corporation", full: "Tunapuna/Piarco Regional Corporation,Trinidad and Tobago", iso: "TT" },
  { code: 9075959, name: "Western Tobago", full: "Western Tobago,Trinidad and Tobago", iso: "TT" },
  { code: 2158, name: "Taiwan", full: "Taiwan", iso: "TW" },
  { code: 9070385, name: "Arusha Region", full: "Arusha Region,Tanzania", iso: "TZ" },
  { code: 9069885, name: "Dodoma Region", full: "Dodoma Region,Tanzania", iso: "TZ" },
  { code: 9069889, name: "Iringa Region", full: "Iringa Region,Tanzania", iso: "TZ" },
  { code: 9069890, name: "Kagera Region", full: "Kagera Region,Tanzania", iso: "TZ" },
  { code: 9069880, name: "Kigoma Region", full: "Kigoma Region,Tanzania", iso: "TZ" },
  { code: 9069877, name: "Kilimanjaro Region", full: "Kilimanjaro Region,Tanzania", iso: "TZ" },
  { code: 9070383, name: "Lindi Region", full: "Lindi Region,Tanzania", iso: "TZ" },
  { code: 9069878, name: "Manyara Region", full: "Manyara Region,Tanzania", iso: "TZ" },
  { code: 9069881, name: "Mara Region", full: "Mara Region,Tanzania", iso: "TZ" },
  { code: 9069879, name: "Mbeya Region", full: "Mbeya Region,Tanzania", iso: "TZ" },
  { code: 9069882, name: "Mjini Magharibi Region", full: "Mjini Magharibi Region,Tanzania", iso: "TZ" },
  { code: 9069894, name: "Morogoro Region", full: "Morogoro Region,Tanzania", iso: "TZ" },
  { code: 9070384, name: "Mtwara Region", full: "Mtwara Region,Tanzania", iso: "TZ" },
  { code: 9069891, name: "Mwanza Region", full: "Mwanza Region,Tanzania", iso: "TZ" },
  { code: 9075968, name: "Pemba North Region", full: "Pemba North Region,Tanzania", iso: "TZ" },
  { code: 9069895, name: "Pwani Region", full: "Pwani Region,Tanzania", iso: "TZ" },
  { code: 9069887, name: "Rukwa Region", full: "Rukwa Region,Tanzania", iso: "TZ" },
  { code: 9069893, name: "Ruvuma Region", full: "Ruvuma Region,Tanzania", iso: "TZ" },
  { code: 9069892, name: "Shinyanga Region", full: "Shinyanga Region,Tanzania", iso: "TZ" },
  { code: 9069884, name: "Singida Region", full: "Singida Region,Tanzania", iso: "TZ" },
  { code: 9069888, name: "Tabora Region", full: "Tabora Region,Tanzania", iso: "TZ" },
  { code: 9069886, name: "Tanga Region", full: "Tanga Region,Tanzania", iso: "TZ" },
  { code: 9070382, name: "Unguja North Region", full: "Unguja North Region,Tanzania", iso: "TZ" },
  { code: 9069883, name: "Unguja South Region", full: "Unguja South Region,Tanzania", iso: "TZ" },
  { code: 21128, name: "Cherkasy Oblast", full: "Cherkasy Oblast,Ukraine", iso: "UA" },
  { code: 21129, name: "Chernihiv Oblast", full: "Chernihiv Oblast,Ukraine", iso: "UA" },
  { code: 21130, name: "Chernivtsi Oblast", full: "Chernivtsi Oblast,Ukraine", iso: "UA" },
  { code: 21112, name: "Dnipropetrovsk Oblast", full: "Dnipropetrovsk Oblast,Ukraine", iso: "UA" },
  { code: 21113, name: "Donetsk Oblast", full: "Donetsk Oblast,Ukraine", iso: "UA" },
  { code: 21117, name: "Ivano-Frankivsk Oblast", full: "Ivano-Frankivsk Oblast,Ukraine", iso: "UA" },
  { code: 21125, name: "Kharkiv Oblast", full: "Kharkiv Oblast,Ukraine", iso: "UA" },
  { code: 21126, name: "Kherson Oblast", full: "Kherson Oblast,Ukraine", iso: "UA" },
  { code: 21127, name: "Khmelnytskyi Oblast", full: "Khmelnytskyi Oblast,Ukraine", iso: "UA" },
  { code: 21119, name: "Kirovohrad Oblast", full: "Kirovohrad Oblast,Ukraine", iso: "UA" },
  { code: 21580, name: "Kyiv Oblast", full: "Kyiv Oblast,Ukraine", iso: "UA" },
  { code: 21118, name: "Kyiv city", full: "Kyiv city,Ukraine", iso: "UA" },
  { code: 21111, name: "Luhansk Oblast", full: "Luhansk Oblast,Ukraine", iso: "UA" },
  { code: 21121, name: "Lviv Oblast", full: "Lviv Oblast,Ukraine", iso: "UA" },
  { code: 21581, name: "Mykolaiv Oblast", full: "Mykolaiv Oblast,Ukraine", iso: "UA" },
  { code: 21122, name: "Odessa Oblast", full: "Odessa Oblast,Ukraine", iso: "UA" },
  { code: 21123, name: "Poltava Oblast", full: "Poltava Oblast,Ukraine", iso: "UA" },
  { code: 21582, name: "Rivne Oblast", full: "Rivne Oblast,Ukraine", iso: "UA" },
  { code: 21124, name: "Sumy Oblast", full: "Sumy Oblast,Ukraine", iso: "UA" },
  { code: 21292, name: "Ternopil Oblast", full: "Ternopil Oblast,Ukraine", iso: "UA" },
  { code: 21109, name: "Vinnytsia Oblast", full: "Vinnytsia Oblast,Ukraine", iso: "UA" },
  { code: 21110, name: "Volyn Oblast", full: "Volyn Oblast,Ukraine", iso: "UA" },
  { code: 21115, name: "Zakarpattia Oblast", full: "Zakarpattia Oblast,Ukraine", iso: "UA" },
  { code: 21116, name: "Zaporizhia Oblast", full: "Zaporizhia Oblast,Ukraine", iso: "UA" },
  { code: 21114, name: "Zhytomyr Oblast", full: "Zhytomyr Oblast,Ukraine", iso: "UA" },
  { code: 9069985, name: "Central Region", full: "Central Region,Uganda", iso: "UG" },
  { code: 9069988, name: "Eastern Region", full: "Eastern Region,Uganda", iso: "UG" },
  { code: 9069987, name: "Northern Region", full: "Northern Region,Uganda", iso: "UG" },
  { code: 9069986, name: "Western Region", full: "Western Region,Uganda", iso: "UG" },
  { code: 21133, name: "Alabama", full: "Alabama,United States", iso: "US" },
  { code: 21132, name: "Alaska", full: "Alaska,United States", iso: "US" },
  { code: 21136, name: "Arizona", full: "Arizona,United States", iso: "US" },
  { code: 21135, name: "Arkansas", full: "Arkansas,United States", iso: "US" },
  { code: 21137, name: "California", full: "California,United States", iso: "US" },
  { code: 21138, name: "Colorado", full: "Colorado,United States", iso: "US" },
  { code: 21139, name: "Connecticut", full: "Connecticut,United States", iso: "US" },
  { code: 21141, name: "Delaware", full: "Delaware,United States", iso: "US" },
  { code: 21140, name: "District of Columbia", full: "District of Columbia,United States", iso: "US" },
  { code: 21142, name: "Florida", full: "Florida,United States", iso: "US" },
  { code: 21143, name: "Georgia", full: "Georgia,United States", iso: "US" },
  { code: 21144, name: "Hawaii", full: "Hawaii,United States", iso: "US" },
  { code: 21146, name: "Idaho", full: "Idaho,United States", iso: "US" },
  { code: 21147, name: "Illinois", full: "Illinois,United States", iso: "US" },
  { code: 21148, name: "Indiana", full: "Indiana,United States", iso: "US" },
  { code: 21145, name: "Iowa", full: "Iowa,United States", iso: "US" },
  { code: 21149, name: "Kansas", full: "Kansas,United States", iso: "US" },
  { code: 21150, name: "Kentucky", full: "Kentucky,United States", iso: "US" },
  { code: 21151, name: "Louisiana", full: "Louisiana,United States", iso: "US" },
  { code: 21154, name: "Maine", full: "Maine,United States", iso: "US" },
  { code: 21153, name: "Maryland", full: "Maryland,United States", iso: "US" },
  { code: 21152, name: "Massachusetts", full: "Massachusetts,United States", iso: "US" },
  { code: 21155, name: "Michigan", full: "Michigan,United States", iso: "US" },
  { code: 21156, name: "Minnesota", full: "Minnesota,United States", iso: "US" },
  { code: 21158, name: "Mississippi", full: "Mississippi,United States", iso: "US" },
  { code: 21157, name: "Missouri", full: "Missouri,United States", iso: "US" },
  { code: 21159, name: "Montana", full: "Montana,United States", iso: "US" },
  { code: 21162, name: "Nebraska", full: "Nebraska,United States", iso: "US" },
  { code: 21166, name: "Nevada", full: "Nevada,United States", iso: "US" },
  { code: 21163, name: "New Hampshire", full: "New Hampshire,United States", iso: "US" },
  { code: 21164, name: "New Jersey", full: "New Jersey,United States", iso: "US" },
  { code: 21165, name: "New Mexico", full: "New Mexico,United States", iso: "US" },
  { code: 21167, name: "New York", full: "New York,United States", iso: "US" },
  { code: 21160, name: "North Carolina", full: "North Carolina,United States", iso: "US" },
  { code: 21161, name: "North Dakota", full: "North Dakota,United States", iso: "US" },
  { code: 21168, name: "Ohio", full: "Ohio,United States", iso: "US" },
  { code: 21169, name: "Oklahoma", full: "Oklahoma,United States", iso: "US" },
  { code: 21170, name: "Oregon", full: "Oregon,United States", iso: "US" },
  { code: 21171, name: "Pennsylvania", full: "Pennsylvania,United States", iso: "US" },
  { code: 21172, name: "Rhode Island", full: "Rhode Island,United States", iso: "US" },
  { code: 9073451, name: "San Francisco Bay Area", full: "San Francisco Bay Area,California,United States", iso: "US" },
  { code: 9073452, name: "Silicon Valley", full: "Silicon Valley,California,United States", iso: "US" },
  { code: 21173, name: "South Carolina", full: "South Carolina,United States", iso: "US" },
  { code: 21174, name: "South Dakota", full: "South Dakota,United States", iso: "US" },
  { code: 21175, name: "Tennessee", full: "Tennessee,United States", iso: "US" },
  { code: 21176, name: "Texas", full: "Texas,United States", iso: "US" },
  { code: 21177, name: "Utah", full: "Utah,United States", iso: "US" },
  { code: 21179, name: "Vermont", full: "Vermont,United States", iso: "US" },
  { code: 21178, name: "Virginia", full: "Virginia,United States", iso: "US" },
  { code: 21180, name: "Washington", full: "Washington,United States", iso: "US" },
  { code: 21183, name: "West Virginia", full: "West Virginia,United States", iso: "US" },
  { code: 21182, name: "Wisconsin", full: "Wisconsin,United States", iso: "US" },
  { code: 21184, name: "Wyoming", full: "Wyoming,United States", iso: "US" },
  { code: 9075972, name: "Andijan region", full: "Andijan region,Uzbekistan", iso: "UZ" },
  { code: 9075970, name: "Bukhara Region", full: "Bukhara Region,Uzbekistan", iso: "UZ" },
  { code: 9075982, name: "Fergana Region", full: "Fergana Region,Uzbekistan", iso: "UZ" },
  { code: 9075971, name: "Jizzakh Region", full: "Jizzakh Region,Uzbekistan", iso: "UZ" },
  { code: 9075977, name: "Namangan Region", full: "Namangan Region,Uzbekistan", iso: "UZ" },
  { code: 9075978, name: "Navoiy Region", full: "Navoiy Region,Uzbekistan", iso: "UZ" },
  { code: 9075973, name: "Qashqadaryo Region", full: "Qashqadaryo Region,Uzbekistan", iso: "UZ" },
  { code: 9075975, name: "Republic of Karakalpakstan", full: "Republic of Karakalpakstan,Uzbekistan", iso: "UZ" },
  { code: 9075980, name: "Samarqand Region", full: "Samarqand Region,Uzbekistan", iso: "UZ" },
  { code: 9075979, name: "Sirdaryo Region", full: "Sirdaryo Region,Uzbekistan", iso: "UZ" },
  { code: 9075976, name: "Surxondaryo Region", full: "Surxondaryo Region,Uzbekistan", iso: "UZ" },
  { code: 9075981, name: "Tashkent Region", full: "Tashkent Region,Uzbekistan", iso: "UZ" },
  { code: 9075974, name: "Xorazm Region", full: "Xorazm Region,Uzbekistan", iso: "UZ" },
  { code: 9075985, name: "Charlotte", full: "Charlotte,Saint Vincent and the Grenadines", iso: "VC" },
  { code: 9075983, name: "Grenadines", full: "Grenadines,Saint Vincent and the Grenadines", iso: "VC" },
  { code: 9075986, name: "St. Andrew", full: "St. Andrew,Saint Vincent and the Grenadines", iso: "VC" },
  { code: 9075987, name: "St. George", full: "St. George,Saint Vincent and the Grenadines", iso: "VC" },
  { code: 9075984, name: "St. Patrick", full: "St. Patrick,Saint Vincent and the Grenadines", iso: "VC" },
  { code: 9069667, name: "Amazonas", full: "Amazonas,Venezuela", iso: "VE" },
  { code: 9069665, name: "Cojedes", full: "Cojedes,Venezuela", iso: "VE" },
  { code: 9069666, name: "Delta Amacuro", full: "Delta Amacuro,Venezuela", iso: "VE" },
  { code: 9069664, name: "Federal Dependencies of Venezuela", full: "Federal Dependencies of Venezuela,Venezuela", iso: "VE" },
  { code: 9075988, name: "Vargas", full: "Vargas,Venezuela", iso: "VE" },
  { code: 2092, name: "British Virgin Islands", full: "British Virgin Islands", iso: "VG" },
  { code: 2850, name: "U.S. Virgin Islands", full: "U.S. Virgin Islands", iso: "VI" },
  { code: 2900, name: "Kosovo", full: "Kosovo", iso: "XK" },
  { code: 2175, name: "Mayotte", full: "Mayotte", iso: "YT" }
];

export const GEO_LANGUAGES: GeoLanguage[] = [
  { name: "Afrikaans", code: "af" },
  { name: "Akan", code: "ak" },
  { name: "Albanian", code: "sq" },
  { name: "Amharic", code: "am" },
  { name: "Arabic", code: "ar" },
  { name: "Armenian", code: "hy" },
  { name: "Azeri", code: "az" },
  { name: "Balinese", code: "ban" },
  { name: "Basque", code: "eu" },
  { name: "Belarusian", code: "be" },
  { name: "Bengali", code: "bn" },
  { name: "Bosnian", code: "bs" },
  { name: "Bulgarian", code: "bg" },
  { name: "Burmese", code: "my" },
  { name: "Catalan", code: "ca" },
  { name: "Cebuano", code: "ceb" },
  { name: "Chichewa", code: "ny" },
  { name: "Chinese (Simplified)", code: "zh-CN" },
  { name: "Chinese (Traditional)", code: "zh-TW" },
  { name: "Croatian", code: "hr" },
  { name: "Czech", code: "cs" },
  { name: "Danish", code: "da" },
  { name: "Dutch", code: "nl" },
  { name: "English", code: "en" },
  { name: "Espanol (Latinoamerica)", code: "es-419" },
  { name: "Estonian", code: "et" },
  { name: "Ewe", code: "ee" },
  { name: "Faroese", code: "fo" },
  { name: "Farsi", code: "fa" },
  { name: "Filipino", code: "fil" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "Frisian", code: "fy" },
  { name: "Ga", code: "gaa" },
  { name: "Galician", code: "gl" },
  { name: "Ganda", code: "lg" },
  { name: "Georgian", code: "ka" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "Gujarati", code: "gu" },
  { name: "Haitian", code: "ht" },
  { name: "Hausa", code: "ha" },
  { name: "Hebrew", code: "he" },
  { name: "Hebrew (old)", code: "iw" },
  { name: "Hindi", code: "hi" },
  { name: "Hungarian", code: "hu" },
  { name: "Icelandic", code: "is" },
  { name: "IciBemba", code: "bem" },
  { name: "Igbo", code: "ig" },
  { name: "Indonesian", code: "id" },
  { name: "Irish", code: "ga" },
  { name: "Italian", code: "it" },
  { name: "Japanese", code: "ja" },
  { name: "Kannada", code: "kn" },
  { name: "Kazakh", code: "kk" },
  { name: "Khmer", code: "km" },
  { name: "Kinyarwanda", code: "rw" },
  { name: "Kirundi", code: "rn" },
  { name: "Kongo", code: "kg" },
  { name: "Korean", code: "ko" },
  { name: "Kreol morisien", code: "mfe" },
  { name: "Kreol Seselwa", code: "crs" },
  { name: "Krio", code: "kri" },
  { name: "Kurdish", code: "ckb" },
  { name: "Kyrgyz", code: "ky" },
  { name: "Lao", code: "lo" },
  { name: "Latvian", code: "lv" },
  { name: "Lingala", code: "ln" },
  { name: "Lithuanian", code: "lt" },
  { name: "Luo", code: "ach" },
  { name: "Macedonian", code: "mk" },
  { name: "Malagasy", code: "mg" },
  { name: "Malay", code: "ms" },
  { name: "Malayam", code: "ml" },
  { name: "Maltese", code: "mt" },
  { name: "Maori", code: "mi" },
  { name: "Marathi", code: "mr" },
  { name: "Mongolian", code: "mn" },
  { name: "Montenegro", code: "sr-ME" },
  { name: "Nepali", code: "ne" },
  { name: "Northern Sotho", code: "nso" },
  { name: "Norwegian", code: "no" },
  { name: "Nyankole", code: "nyn" },
  { name: "Oromo", code: "om" },
  { name: "Pashto", code: "ps" },
  { name: "Pidgin", code: "pcm" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt" },
  { name: "Portuguese (Brazil)", code: "pt-BR" },
  { name: "Portuguese (Portugal)", code: "pt-PT" },
  { name: "Punjabi", code: "pa" },
  { name: "Quechua", code: "qu" },
  { name: "Romanian", code: "ro" },
  { name: "Romansh", code: "rm" },
  { name: "Russian", code: "ru" },
  { name: "Serbian", code: "sr" },
  { name: "Serbian (Latin)", code: "sr-Latn" },
  { name: "Sesotho", code: "st" },
  { name: "Shona", code: "sn" },
  { name: "Silozi", code: "loz" },
  { name: "Sindhi", code: "sd" },
  { name: "Sinhalese", code: "si" },
  { name: "Slovak", code: "sk" },
  { name: "Slovenian", code: "sl" },
  { name: "Somali", code: "so" },
  { name: "Spanish", code: "es" },
  { name: "Swahili", code: "sw" },
  { name: "Swedish", code: "sv" },
  { name: "Tajik", code: "tg" },
  { name: "Tamil", code: "ta" },
  { name: "Telugu", code: "te" },
  { name: "Thai", code: "th" },
  { name: "Tigrinya", code: "ti" },
  { name: "Tonga (Tonga Islands)", code: "to" },
  { name: "Tshiluba", code: "lua" },
  { name: "Tswana", code: "tn" },
  { name: "Tumbuka", code: "tum" },
  { name: "Turkish", code: "tr" },
  { name: "Turkmen", code: "tk" },
  { name: "Ukrainian", code: "uk" },
  { name: "Urdu", code: "ur" },
  { name: "Uzbek", code: "uz" },
  { name: "Vietnamese", code: "vi" },
  { name: "Wolof", code: "wo" },
  { name: "Xhosa", code: "xh" },
  { name: "Yoruba", code: "yo" },
  { name: "Zulu", code: "zu" }
];

export const GEO_COUNTRY_BY_ISO: Record<string, GeoCountry> =
  Object.fromEntries(GEO_COUNTRIES.map((c) => [c.iso, c]));

export const GEO_REGIONS_BY_ISO: Record<string, GeoRegion[]> =
  GEO_REGIONS.reduce<Record<string, GeoRegion[]>>((acc, r) => {
    if (!acc[r.iso]) acc[r.iso] = [];
    acc[r.iso]!.push(r);
    return acc;
  }, {});
